import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never;
    };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Upload: { input: globalThis.File; output: globalThis.File };
  Float: { input: number; output: number };
  Any: { input: unknown; output: unknown };
  Date: { input: string; output: string };
  DateTime: { input: string; output: string };
  Decimal: { input: number; output: number };
  Identifier: { input: string; output: string };
  LongInt: { input: number; output: number };
  RawJson: { input: Record<string, unknown>; output: Record<string, unknown> };
  StringOrIntegerRange: {
    input: string | { min: number; max: number };
    output: string | { min: number; max: number };
  };
};

export type Address = {
  __typename?: "Address";
  lineOne: Maybe<Scalars["String"]["output"]>;
  postalCode: Maybe<Scalars["String"]["output"]>;
};

export type BuyerIntentAttributeFilter = {
  ids?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
};

export type BuyerIntentCategoryFilter = {
  ids?: InputMaybe<Array<InputMaybe<Scalars["Identifier"]["input"]>>>;
};

export type BuyerIntentProductFilter = {
  ids?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  inclusionMethod?: InputMaybe<InclusionMethod>;
};

export type BuyerIntentVendorFilter = {
  ids?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  inclusionMethod?: InputMaybe<InclusionMethod>;
};

export type BuyersJourneyScore = {
  buyersJourneyIds: Array<InputMaybe<Scalars["Identifier"]["input"]>>;
  score?: Scalars["Int"]["input"];
  topics: IdentInclusionFilter;
};

export type CategoryMinMaxScore = {
  categoryId: Scalars["Identifier"]["input"];
  max?: InputMaybe<Scalars["Int"]["input"]>;
  min?: InputMaybe<Scalars["Int"]["input"]>;
  score?: Scalars["Int"]["input"];
};

export type CloudDynamics = {
  __typename?: "CloudDynamics";
  domainRank: Maybe<Scalars["Int"]["output"]>;
  domains: Maybe<DomainsPaginated>;
  providerDistribution: Maybe<Array<Maybe<CloudProviderDistribution>>>;
  spends: Maybe<CloudSpends>;
  trafficDistribution: Maybe<TrafficDistribution>;
};

export type CloudDynamicsDomainsArgs = {
  page?: InputMaybe<Scalars["Int"]["input"]>;
  per?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type CloudMaturity = {
  __typename?: "CloudMaturity";
  awsCount: Maybe<Scalars["Int"]["output"]>;
  azureCount: Maybe<Scalars["Int"]["output"]>;
  cloudProportionChangeDelta: Maybe<Scalars["Float"]["output"]>;
  currentTechStackAllProductsCount: Maybe<Scalars["Int"]["output"]>;
  currentTechStackCloudProductsCount: Maybe<Scalars["Int"]["output"]>;
  currentTechStackCloudProductsRatio: Maybe<Scalars["Float"]["output"]>;
  gcpCount: Maybe<Scalars["Int"]["output"]>;
  hgId: Maybe<Scalars["Identifier"]["output"]>;
  newServicesAllProductsCount: Maybe<Scalars["Int"]["output"]>;
  newServicesCloudProductsCount: Maybe<Scalars["Int"]["output"]>;
  newServicesCloudProductsRatio: Maybe<Scalars["Float"]["output"]>;
  urlId: Maybe<Scalars["Identifier"]["output"]>;
};

export type CloudMaturityData = {
  __typename?: "CloudMaturityData";
  count: Maybe<Scalars["Int"]["output"]>;
  data: Maybe<Array<Maybe<CloudMaturity>>>;
};

export type CloudMaturityScore = {
  fullTechStackRangeId?: InputMaybe<Scalars["Identifier"]["input"]>;
  newServicesRangeId?: InputMaybe<Scalars["Identifier"]["input"]>;
  score?: Scalars["Int"]["input"];
};

export type CloudProviderDistribution = {
  __typename?: "CloudProviderDistribution";
  imageUrl: Maybe<Scalars["String"]["output"]>;
  providerName: Maybe<Scalars["String"]["output"]>;
  spend: Maybe<CloudSpend>;
  startedAt: Maybe<Scalars["Date"]["output"]>;
};

export type CloudSpend = {
  __typename?: "CloudSpend";
  amount: Maybe<Scalars["Int"]["output"]>;
  period: Maybe<Scalars["String"]["output"]>;
};

export type CloudSpends = {
  __typename?: "CloudSpends";
  cloudHosting: Maybe<CloudSpend>;
  dataCenterHosting: Maybe<CloudSpend>;
  total: Maybe<CloudSpend>;
};

export type Company = {
  __typename?: "Company";
  address: Maybe<Address>;
  description: Maybe<Scalars["String"]["output"]>;
  duns: Maybe<Scalars["String"]["output"]>;
  employees: Maybe<Scalars["Int"]["output"]>;
  fiscalYearEndMonth: Maybe<Scalars["Int"]["output"]>;
  hgId: Maybe<Scalars["Identifier"]["output"]>;
  industry: Maybe<Industry>;
  installedProductIds: Maybe<Array<Maybe<Scalars["Int"]["output"]>>>;
  installedVendorIds: Maybe<Array<Maybe<Scalars["Int"]["output"]>>>;
  isDu: Maybe<Scalars["Boolean"]["output"]>;
  isGu: Maybe<Scalars["Boolean"]["output"]>;
  itSpend: Maybe<Scalars["Int"]["output"]>;
  latitude: Maybe<Scalars["Float"]["output"]>;
  locationPrimary: Maybe<Geo>;
  locations: Maybe<Scalars["Int"]["output"]>;
  longitude: Maybe<Scalars["Float"]["output"]>;
  naics2012: Maybe<Naics2012>;
  name: Maybe<Scalars["String"]["output"]>;
  orgTree: Maybe<OrgTree>;
  ownershipType: Maybe<Scalars["String"]["output"]>;
  parent: Maybe<ParentCompany>;
  revenue: Maybe<Scalars["Int"]["output"]>;
  scores: Maybe<Scalars["RawJson"]["output"]>;
  stockExchange: Maybe<StockExchange>;
  telephone: Maybe<Scalars["String"]["output"]>;
  telephoneCountryCode: Maybe<Scalars["String"]["output"]>;
  url: Maybe<Scalars["String"]["output"]>;
};

export type CompanyData = {
  __typename?: "CompanyData";
  count: Maybe<Scalars["Int"]["output"]>;
  data: Maybe<Array<Maybe<Company>>>;
};

export type CompanyFilter = {
  companyMatch?: InputMaybe<CompanyMatchFilter>;
  companyPromotionDate?: InputMaybe<CompanyPromotionDateFilter>;
  countryAlpha2s?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  duns?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  employees?: InputMaybe<MinMaxFilter>;
  excludedCountryAlpha2s?: InputMaybe<
    Array<InputMaybe<Scalars["String"]["input"]>>
  >;
  forbes2000?: InputMaybe<Scalars["Boolean"]["input"]>;
  fortune500?: InputMaybe<Scalars["Boolean"]["input"]>;
  fuzzySearch?: InputMaybe<Scalars["String"]["input"]>;
  hasFinancingEvent?: InputMaybe<HasFinancingEventFilter>;
  hasFixedEmployees?: InputMaybe<Scalars["Boolean"]["input"]>;
  hasFixedRevenue?: InputMaybe<Scalars["Boolean"]["input"]>;
  hgIds?: InputMaybe<Array<InputMaybe<Scalars["Identifier"]["input"]>>>;
  hgIdsIncludingCorporateRelatives?: InputMaybe<
    Array<InputMaybe<Scalars["Identifier"]["input"]>>
  >;
  hgIdsTables?: InputMaybe<Array<InputMaybe<TableFilter>>>;
  industry?: InputMaybe<IndustryFilter>;
  intent?: InputMaybe<IntentFilter>;
  isDp?: InputMaybe<Scalars["Boolean"]["input"]>;
  isDu?: InputMaybe<Scalars["Boolean"]["input"]>;
  isGhq?: InputMaybe<Scalars["Boolean"]["input"]>;
  isGp?: InputMaybe<Scalars["Boolean"]["input"]>;
  isGu?: InputMaybe<Scalars["Boolean"]["input"]>;
  knownCompanies?: InputMaybe<KnownCompaniesFilter>;
  nameOrUrl?: InputMaybe<Scalars["String"]["input"]>;
  productAttributeIds?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  productCategoryIds?: InputMaybe<
    Array<InputMaybe<Scalars["Identifier"]["input"]>>
  >;
  products?: InputMaybe<Array<InputMaybe<InclusionFilter>>>;
  regionNames?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  revenue?: InputMaybe<MinMaxFilter>;
  spend?: InputMaybe<Array<InputMaybe<SpendFilter>>>;
  stateIds?: InputMaybe<Array<InputMaybe<Scalars["Identifier"]["input"]>>>;
  vendors?: InputMaybe<Array<InputMaybe<InclusionFilter>>>;
  whitespace?: InputMaybe<WhitespaceFilter>;
};

export type CompanyLocation = {
  __typename?: "CompanyLocation";
  address: Maybe<Address>;
  cloudDynamics: Maybe<CloudDynamics>;
  corporateParent: Maybe<CorporateParentCompany>;
  description: Maybe<Scalars["String"]["output"]>;
  domesticParent: Maybe<DomesticParentCompany>;
  duns: Maybe<Scalars["String"]["output"]>;
  employeeRange: Maybe<FirmoRange>;
  /** @deprecated Due to the introduction of SMBs to the platform, use employee_range instead */
  employees: Maybe<Scalars["Int"]["output"]>;
  fiscalYearEndMonth: Maybe<Scalars["Int"]["output"]>;
  forbes2000: Maybe<Scalars["Int"]["output"]>;
  fortune500: Maybe<Scalars["Int"]["output"]>;
  hgId: Maybe<Scalars["Identifier"]["output"]>;
  industry: Maybe<Industry>;
  installedProductIds: Maybe<Array<Maybe<Scalars["Int"]["output"]>>>;
  installedVendorIds: Maybe<Array<Maybe<Scalars["Int"]["output"]>>>;
  isDp: Maybe<Scalars["Boolean"]["output"]>;
  isDu: Maybe<Scalars["Boolean"]["output"]>;
  isGhq: Maybe<Scalars["Boolean"]["output"]>;
  isGp: Maybe<Scalars["Boolean"]["output"]>;
  isGu: Maybe<Scalars["Boolean"]["output"]>;
  isMultiNational: Maybe<Scalars["Boolean"]["output"]>;
  itSpend: Maybe<Scalars["Int"]["output"]>;
  latitude: Maybe<Scalars["Float"]["output"]>;
  locationPrimary: Maybe<Geo>;
  locations: Maybe<Scalars["Int"]["output"]>;
  longitude: Maybe<Scalars["Float"]["output"]>;
  naics2012: Maybe<Naics2012>;
  naics2012Agg: Maybe<Naics2012Agg>;
  name: Maybe<Scalars["String"]["output"]>;
  orgTree: Maybe<OrgTree>;
  ownershipType: Maybe<Scalars["String"]["output"]>;
  parent: Maybe<ParentCompany>;
  /** @deprecated Due to the introduction of SMBs to the platform, use revenue_range instead */
  revenue: Maybe<Scalars["Int"]["output"]>;
  revenueRange: Maybe<FirmoRange>;
  royaltyRate: Maybe<Scalars["String"]["output"]>;
  scores: Maybe<Scalars["RawJson"]["output"]>;
  sicUs1987: Maybe<SicUs1987>;
  sicUs1987Agg: Maybe<SicUs1987Agg>;
  stockExchange: Maybe<StockExchange>;
  telephone: Maybe<Scalars["String"]["output"]>;
  telephoneCountryCode: Maybe<Scalars["String"]["output"]>;
  url: Maybe<Scalars["String"]["output"]>;
  urlId: Maybe<Scalars["Identifier"]["output"]>;
  urlInstall: Maybe<Scalars["String"]["output"]>;
  urlInstallId: Maybe<Scalars["Identifier"]["output"]>;
};

export type CompanyLocationsData = {
  __typename?: "CompanyLocationsData";
  arguments: Maybe<Array<Maybe<Scalars["Any"]["output"]>>>;
  count: Maybe<Scalars["Int"]["output"]>;
  data: Maybe<Array<Maybe<CompanyLocation>>>;
  queryBrokerFilter: Maybe<Scalars["RawJson"]["output"]>;
  statement: Maybe<Scalars["String"]["output"]>;
};

export type CompanyMatchFilter = {
  fileId?: InputMaybe<Scalars["Identifier"]["input"]>;
  fileName?: InputMaybe<Scalars["String"]["input"]>;
  filterMethod?: InputMaybe<FilterMethod>;
  includeHierarchy?: InputMaybe<Scalars["Boolean"]["input"]>;
  enforceCountryMatch?: InputMaybe<Scalars["Boolean"]["input"]>;
  invalidRows?: InputMaybe<Scalars["Int"]["input"]>;
  lastMatched?: InputMaybe<Scalars["DateTime"]["input"]>;
  matchedRows?: InputMaybe<Scalars["Int"]["input"]>;
  processedChunks?: InputMaybe<Scalars["Int"]["input"]>;
  totalChunks?: InputMaybe<Scalars["Int"]["input"]>;
  totalRows?: InputMaybe<Scalars["Int"]["input"]>;
  uploaded?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type CompanyProfileInstallFilters = {
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars["Identifier"]["input"]>>>;
  countryAlpha2s?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  productIds?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  vendorIds?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
};

export type CompanyProfileInstallParams = {
  filters?: InputMaybe<OpportunityGeneratorFilter>;
  includeCorporateDescendants?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type CompanyProfileIntentParams = {
  filters?: InputMaybe<IntentFilter>;
  includeCorporateDescendants?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type CompanyPromotionDateFilter = {
  date: Scalars["Date"]["input"];
  operator: CompanyPromotionDateOperator;
};

export enum CompanyPromotionDateOperator {
  EQUAL_TO = "EQUAL_TO",
  GREATER_THAN = "GREATER_THAN",
  LESS_THAN = "LESS_THAN",
}

export type CompanySearchResult = {
  __typename?: "CompanySearchResult";
  duns: Maybe<Scalars["String"]["output"]>;
  employeeRange: Maybe<FirmoRange>;
  hgId: Maybe<Scalars["String"]["output"]>;
  isDp: Maybe<Scalars["Boolean"]["output"]>;
  isDu: Maybe<Scalars["Boolean"]["output"]>;
  isGhq: Maybe<Scalars["Boolean"]["output"]>;
  isGp: Maybe<Scalars["Boolean"]["output"]>;
  isGu: Maybe<Scalars["Boolean"]["output"]>;
  itSpend: Maybe<Scalars["Int"]["output"]>;
  locationPrimary: Maybe<Geo>;
  name: Maybe<Scalars["String"]["output"]>;
  revenueRange: Maybe<FirmoRange>;
  url: Maybe<Scalars["String"]["output"]>;
};

export type CompanySearchResultsData = {
  __typename?: "CompanySearchResultsData";
  count: Maybe<Scalars["Int"]["output"]>;
  data: Maybe<Array<Maybe<CompanySearchResult>>>;
};

export enum CompanyTypes {
  DP = "DP",
  DU = "DU",
  GHQ = "GHQ",
  GP = "GP",
  GU = "GU",
}

export type ContextAggregate = {
  __typename?: "ContextAggregate";
  contextIds: Maybe<Array<Maybe<Scalars["Identifier"]["output"]>>>;
  typeNames: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
};

export type ContextTypeScore = {
  contextTypeIds: Array<InputMaybe<Scalars["Identifier"]["input"]>>;
  score?: Scalars["Int"]["input"];
  topics: IdentInclusionFilter;
};

export type Contract = {
  __typename?: "Contract";
  announcementDate: Maybe<Scalars["Date"]["output"]>;
  bidProcess: Maybe<Scalars["String"]["output"]>;
  contractEvent: Maybe<Scalars["String"]["output"]>;
  contractStructure: Maybe<Scalars["String"]["output"]>;
  customerDrivers: Maybe<Scalars["String"]["output"]>;
  customerDuns: Maybe<Scalars["Int"]["output"]>;
  customerId: Maybe<Scalars["String"]["output"]>;
  customerName: Maybe<Scalars["String"]["output"]>;
  dealValue: Maybe<Scalars["Int"]["output"]>;
  endDate: Maybe<Scalars["Date"]["output"]>;
  hgId: Maybe<Scalars["Identifier"]["output"]>;
  id: Maybe<Scalars["Identifier"]["output"]>;
  isActive: Maybe<Scalars["Boolean"]["output"]>;
  largerContract: Maybe<Scalars["Boolean"]["output"]>;
  performanceCriteria: Maybe<Scalars["String"]["output"]>;
  pricingStructure: Maybe<Scalars["String"]["output"]>;
  primaryVendor: Maybe<Company>;
  relationshipStructure: Maybe<Scalars["String"]["output"]>;
  /** List of the contract's service lines , optionally providing sort details */
  serviceLines: Maybe<Array<Maybe<ServiceLine>>>;
  signingCountry: Maybe<Scalars["String"]["output"]>;
  startDate: Maybe<Scalars["Date"]["output"]>;
  summary: Maybe<Scalars["String"]["output"]>;
  term: Maybe<Scalars["Int"]["output"]>;
  title: Maybe<Scalars["String"]["output"]>;
  totalServiceLineCount: Maybe<Scalars["Int"]["output"]>;
};

export type ContractServiceLinesArgs = {
  sort?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type ContractData = {
  __typename?: "ContractData";
  count: Maybe<Scalars["Int"]["output"]>;
  data: Maybe<Array<Maybe<Contract>>>;
};

export type CorporateParentCompany = {
  __typename?: "CorporateParentCompany";
  hgId: Maybe<Scalars["Identifier"]["output"]>;
  name: Maybe<Scalars["String"]["output"]>;
};

export type Country = {
  __typename?: "Country";
  alpha2: Maybe<Scalars["String"]["output"]>;
  continent: Maybe<Scalars["String"]["output"]>;
  name: Maybe<Scalars["String"]["output"]>;
  region: Maybe<Region>;
  subcontinent: Maybe<Scalars["String"]["output"]>;
};

export type CountrySpendBreakdown = {
  __typename?: "CountrySpendBreakdown";
  /** Not supported for custom category. */
  averageKnownSpend: Maybe<Scalars["Int"]["output"]>;
  companyCount: Maybe<Scalars["Int"]["output"]>;
  countryId: Maybe<Scalars["Identifier"]["output"]>;
  countryName: Maybe<Scalars["String"]["output"]>;
  totalSpend: Maybe<Scalars["Int"]["output"]>;
};

export type CustomSpendCategory = {
  categories: Array<InputMaybe<CustomSpendCategoryCategory>>;
  name: Scalars["String"]["input"];
};

export type CustomSpendCategoryCategory = {
  id: Scalars["Identifier"]["input"];
  weight: Scalars["Float"]["input"];
};

export type Domain = {
  __typename?: "Domain";
  name: Maybe<Scalars["String"]["output"]>;
};

export type DomainsPaginated = {
  __typename?: "DomainsPaginated";
  count: Maybe<Scalars["Int"]["output"]>;
  data: Maybe<Array<Maybe<Domain>>>;
};

export type DomesticParentCompany = {
  __typename?: "DomesticParentCompany";
  hgId: Maybe<Scalars["Identifier"]["output"]>;
  name: Maybe<Scalars["String"]["output"]>;
};

export type ExportRowCount = {
  __typename?: "ExportRowCount";
  contractsRowCount: Maybe<Scalars["Int"]["output"]>;
  faiRowCount: Maybe<Scalars["Int"]["output"]>;
  installsRowCount: Maybe<Scalars["Int"]["output"]>;
  intentRowCount: Maybe<Scalars["Int"]["output"]>;
};

export type ExportRowCountData = {
  __typename?: "ExportRowCountData";
  data: Maybe<ExportRowCount>;
};

export type File = {
  __typename?: "File";
  url: Scalars["String"]["output"];
};

export enum FilterMethod {
  ADD_FLAG = "ADD_FLAG",
  EXCLUDE_MATCHED = "EXCLUDE_MATCHED",
  FILTER = "FILTER",
}

export type FirmoRange = {
  __typename?: "FirmoRange";
  band: Maybe<Scalars["String"]["output"]>;
  max: Maybe<Scalars["Int"]["output"]>;
  min: Maybe<Scalars["Int"]["output"]>;
};

export type FunctionalAreaIntelligenceByCompany = {
  __typename?: "FunctionalAreaIntelligenceByCompany";
  productId: Maybe<Scalars["Int"]["output"]>;
  productName: Maybe<Scalars["String"]["output"]>;
  signalStrength: Maybe<Scalars["Int"]["output"]>;
};

export type FunctionalAreaIntelligenceByCompanyData = {
  __typename?: "FunctionalAreaIntelligenceByCompanyData";
  data: Maybe<Array<Maybe<FunctionalAreaIntelligenceByCompany>>>;
};

export type FunctionalAreaIntelligenceByCompanySort = {
  direction?: InputMaybe<SortDir>;
  field?: InputMaybe<FunctionalAreaIntelligenceByCompanySortKey>;
};

export enum FunctionalAreaIntelligenceByCompanySortKey {
  SIGNAL_STRENGTH = "SIGNAL_STRENGTH",
}

/** A summary of multiple FAI Records. Maps a Product to a Department in a functional area at a Company, rolling up location specific data. */
export type FunctionalAreaIntelligenceByFunctionalAreaRole = {
  __typename?: "FunctionalAreaIntelligenceByFunctionalAreaRole";
  decisionMaker: Maybe<Scalars["Boolean"]["output"]>;
  functionalAreaRole: Maybe<Scalars["String"]["output"]>;
  functionalAreaRoleDisplayName: Maybe<Scalars["String"]["output"]>;
  functionalAreaRoleSignalStrength: Maybe<Scalars["Int"]["output"]>;
  influencer: Maybe<Scalars["Boolean"]["output"]>;
};

export type FunctionalAreaIntelligenceByLocationSort = {
  direction?: InputMaybe<SortDir>;
  field?: InputMaybe<FunctionalAreaIntelligenceByLocationSortKey>;
};

export enum FunctionalAreaIntelligenceByLocationSortKey {
  CITY = "CITY",
  COUNTRY = "COUNTRY",
  DECISION_MAKER = "DECISION_MAKER",
  FIRST_VERIFIED = "FIRST_VERIFIED",
  INFLUENCER = "INFLUENCER",
  LAST_VERIFIED = "LAST_VERIFIED",
  SIGNAL_STRENGTH = "SIGNAL_STRENGTH",
  STATE = "STATE",
}

/** A summary of multiple FAI Records. Maps a Product to a Department at a Company, rolling up location specific data. */
export type FunctionalAreaIntelligenceByUrl = {
  __typename?: "FunctionalAreaIntelligenceByUrl";
  decisionMaker: Maybe<Scalars["Boolean"]["output"]>;
  department: Maybe<Scalars["String"]["output"]>;
  departmentDisplayName: Maybe<Scalars["String"]["output"]>;
  departmentSignalStrength: Maybe<Scalars["Int"]["output"]>;
  /** List of the roles associated with this department */
  functionalAreaRoles: Maybe<
    Array<Maybe<FunctionalAreaIntelligenceByFunctionalAreaRole>>
  >;
  influencer: Maybe<Scalars["Boolean"]["output"]>;
  productId: Maybe<Scalars["Int"]["output"]>;
  productName: Maybe<Scalars["String"]["output"]>;
  productSignalStrength: Maybe<Scalars["Decimal"]["output"]>;
};

/** A summary of multiple FAI Records. Maps a Product to a Department at a Company, rolling up location specific data. */
export type FunctionalAreaIntelligenceByUrlFunctionalAreaRolesArgs = {
  sort?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type FunctionalAreaIntelligenceByUrlData = {
  __typename?: "FunctionalAreaIntelligenceByUrlData";
  data: Maybe<Array<Maybe<FunctionalAreaIntelligenceByUrl>>>;
};

export type FunctionalAreaIntelligenceByUrlSort = {
  direction?: InputMaybe<SortDir>;
  field?: InputMaybe<FunctionalAreaIntelligenceByUrlSortKey>;
};

export enum FunctionalAreaIntelligenceByUrlSortKey {
  DECISION_MAKER = "DECISION_MAKER",
  DEPARTMENT = "DEPARTMENT",
  DEPARTMENT_DISPLAY_NAME = "DEPARTMENT_DISPLAY_NAME",
  DEPARTMENT_SIGNAL_STRENGTH = "DEPARTMENT_SIGNAL_STRENGTH",
  INFLUENCER = "INFLUENCER",
  PRODUCT_ID = "PRODUCT_ID",
  PRODUCT_NAME = "PRODUCT_NAME",
  PRODUCT_SIGNAL_STRENGTH = "PRODUCT_SIGNAL_STRENGTH",
  URL = "URL",
}

export type FunctionalAreaIntelligenceLocationSort = {
  direction?: InputMaybe<SortDir>;
  field?: InputMaybe<FunctionalAreaIntelligenceLocationSortKey>;
};

export enum FunctionalAreaIntelligenceLocationSortKey {
  CITY = "CITY",
  COUNTRY = "COUNTRY",
  DECISION_MAKER = "DECISION_MAKER",
  FIRST_VERIFIED = "FIRST_VERIFIED",
  INFLUENCER = "INFLUENCER",
  LAST_VERIFIED = "LAST_VERIFIED",
  SIGNAL_STRENGTH = "SIGNAL_STRENGTH",
  STATE = "STATE",
  TITLES = "TITLES",
}

export type FunctionalAreaIntelligenceSummarySort = {
  direction?: InputMaybe<SortDir>;
  field?: InputMaybe<FunctionalAreaIntelligenceSummarySortKey>;
};

export enum FunctionalAreaIntelligenceSummarySortKey {
  DECISION_MAKER = "DECISION_MAKER",
  DEPARTMENT = "DEPARTMENT",
  DEPARTMENT_SIGNAL_STRENGTH = "DEPARTMENT_SIGNAL_STRENGTH",
  INFLUENCER = "INFLUENCER",
  PRODUCT_ID = "PRODUCT_ID",
  PRODUCT_NAME = "PRODUCT_NAME",
  PRODUCT_SIGNAL_STRENGTH = "PRODUCT_SIGNAL_STRENGTH",
  URL = "URL",
}

/** A single FAI Record. Maps a Product to a Department at a Location, with metadata. */
export type FunctionalIntelligenceByLocation = {
  __typename?: "FunctionalIntelligenceByLocation";
  city: Maybe<Scalars["String"]["output"]>;
  country: Maybe<Scalars["String"]["output"]>;
  decisionMaker: Maybe<Scalars["Boolean"]["output"]>;
  decisionMakerTitles: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  firstVerified: Maybe<Scalars["Date"]["output"]>;
  influencer: Maybe<Scalars["Boolean"]["output"]>;
  influencerTitles: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  lastVerified: Maybe<Scalars["Date"]["output"]>;
  signalStrength: Maybe<Scalars["Decimal"]["output"]>;
  state: Maybe<Scalars["String"]["output"]>;
  /** The count of all locations for this product in this functional area at this company */
  totalLocationCount: Maybe<Scalars["Int"]["output"]>;
};

export type FunctionalIntelligenceByLocationData = {
  __typename?: "FunctionalIntelligenceByLocationData";
  count: Maybe<Scalars["Int"]["output"]>;
  data: Maybe<Array<Maybe<FunctionalIntelligenceByLocation>>>;
};

/** A single FAI Record. Maps a Product to a Department at a Location, with metadata. */
export type FunctionalIntelligenceLocation = {
  __typename?: "FunctionalIntelligenceLocation";
  city: Maybe<Scalars["String"]["output"]>;
  country: Maybe<Scalars["String"]["output"]>;
  decisionMaker: Maybe<Scalars["Boolean"]["output"]>;
  firstVerified: Maybe<Scalars["Date"]["output"]>;
  influencer: Maybe<Scalars["Boolean"]["output"]>;
  lastVerified: Maybe<Scalars["Date"]["output"]>;
  signalStrength: Maybe<Scalars["Decimal"]["output"]>;
  state: Maybe<Scalars["String"]["output"]>;
  titles: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  /** The count of all locations for this product in this functional area at this company */
  totalLocationCount: Maybe<Scalars["Int"]["output"]>;
};

export type FunctionalIntelligenceLocationData = {
  __typename?: "FunctionalIntelligenceLocationData";
  count: Maybe<Scalars["Int"]["output"]>;
  data: Maybe<Array<Maybe<FunctionalIntelligenceLocation>>>;
};

/** A summary of multiple FAI Records. Maps a Product to a Department at a Company, rolling up location specific data. */
export type FunctionalIntelligenceSummary = {
  __typename?: "FunctionalIntelligenceSummary";
  decisionMaker: Maybe<Scalars["Boolean"]["output"]>;
  department: Maybe<Scalars["String"]["output"]>;
  departmentSignalStrength: Maybe<Scalars["Int"]["output"]>;
  influencer: Maybe<Scalars["Boolean"]["output"]>;
  productId: Maybe<Scalars["Int"]["output"]>;
  productName: Maybe<Scalars["String"]["output"]>;
  productSignalStrength: Maybe<Scalars["Decimal"]["output"]>;
};

export type FunctionalIntelligenceSummaryData = {
  __typename?: "FunctionalIntelligenceSummaryData";
  count: Maybe<Scalars["Int"]["output"]>;
  data: Maybe<Array<Maybe<FunctionalIntelligenceSummary>>>;
};

export type Geo = {
  __typename?: "Geo";
  city: Maybe<Scalars["String"]["output"]>;
  state: Maybe<State>;
};

export type GeoRange = {
  __typename?: "GeoRange";
  cities: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  id: Maybe<Scalars["Identifier"]["output"]>;
  state: Maybe<State>;
};

export type GeopoliticalRegionSpendBreakdown = {
  __typename?: "GeopoliticalRegionSpendBreakdown";
  companyCount: Maybe<Scalars["Int"]["output"]>;
  regionId: Maybe<Scalars["Identifier"]["output"]>;
  regionName: Maybe<Scalars["String"]["output"]>;
  totalSpend: Maybe<Scalars["Int"]["output"]>;
};

export type GlobalPresenceFilter = {
  hqCountryCodes?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  hqRegions?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  isMultiNational?: InputMaybe<Scalars["Boolean"]["input"]>;
  subsidiaryLocations?: InputMaybe<SubsidiaryPresenceFilter>;
};

export type GlobalPresenceScore = {
  /** List of headquarters country codes */
  hqCountryCodes?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /** List of headquarters regions */
  hqRegions?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /** Whether the company is multi-national */
  isMultiNational?: InputMaybe<Scalars["Boolean"]["input"]>;
  score?: Scalars["Int"]["input"];
  /** Subsidiary locations details */
  subsidiaryLocations?: InputMaybe<SubsidiaryLocationInput>;
};

export type GlobalSettings = {
  companyMatchFile?: InputMaybe<CompanyMatchFilter>;
  competitorPresence?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  geofence?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  hexEncodeIds?: InputMaybe<Scalars["Boolean"]["input"]>;
  installRecency?: InputMaybe<Scalars["Int"]["input"]>;
  isPlatformPermissible?: InputMaybe<Scalars["Boolean"]["input"]>;
  isV1Dataset?: InputMaybe<Scalars["Boolean"]["input"]>;
  localizeInstalls?: InputMaybe<Scalars["Boolean"]["input"]>;
  localizeInstallsForProfile?: InputMaybe<Scalars["Boolean"]["input"]>;
  orgId?: InputMaybe<Scalars["String"]["input"]>;
  rgifExclusiveCompany?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type HasFinancingEventFilter = {
  /** Events discovered in the last N days, counted back from the day the query runs. */
  discoveredWithinDays?: InputMaybe<Scalars["Int"]["input"]>;
  /** Financing rounds to match, e.g. Series A. Any round when omitted. */
  financingTypes?: InputMaybe<Array<Scalars["String"]["input"]>>;
  /** Defaults to ANY_PRESENT (keep only companies with a matching event). */
  inclusionMethod?: InputMaybe<HasFinancingEventInclusionMethod>;
  /** Minimum amount in dollars. Events with no amount are not matched when set. */
  minAmount?: InputMaybe<Scalars["Float"]["input"]>;
};

export enum HasFinancingEventInclusionMethod {
  ANY_PRESENT = "ANY_PRESENT",
  NONE_PRESENT = "NONE_PRESENT",
}

export type IcpEmployeeCountDistributionResult = {
  __typename?: "IcpEmployeeCountDistributionResult";
  count: Maybe<Scalars["Int"]["output"]>;
  employeesRange: Maybe<Scalars["String"]["output"]>;
  employeesRangeMax: Maybe<Scalars["Int"]["output"]>;
  employeesRangeMin: Maybe<Scalars["Int"]["output"]>;
  isSignificant: Maybe<Scalars["Int"]["output"]>;
  /** The share of the distribution that this employee count band represents. */
  share: Maybe<Scalars["Float"]["output"]>;
};

export type IcpEmployeeRangeWinLossResult = {
  __typename?: "IcpEmployeeRangeWinLossResult";
  countLost: Maybe<Scalars["Int"]["output"]>;
  countWon: Maybe<Scalars["Int"]["output"]>;
  employeesRange: Maybe<Scalars["String"]["output"]>;
  employeesRangeMax: Maybe<Scalars["Int"]["output"]>;
  employeesRangeMin: Maybe<Scalars["Int"]["output"]>;
  isSignificant: Maybe<Scalars["Int"]["output"]>;
  minSampleSize: Maybe<Scalars["Float"]["output"]>;
  totalCount: Maybe<Scalars["Int"]["output"]>;
};

export type IcpGeographyDistributionResult = {
  __typename?: "IcpGeographyDistributionResult";
  count: Maybe<Scalars["Int"]["output"]>;
  countryCode: Maybe<Scalars["String"]["output"]>;
  isSignificant: Maybe<Scalars["Int"]["output"]>;
  /** The share of the distribution that this region represents. */
  share: Maybe<Scalars["Float"]["output"]>;
};

export type IcpGeographyWinLossResult = {
  __typename?: "IcpGeographyWinLossResult";
  countLost: Maybe<Scalars["Int"]["output"]>;
  countWon: Maybe<Scalars["Int"]["output"]>;
  countryCode: Maybe<Scalars["String"]["output"]>;
  isSignificant: Maybe<Scalars["Int"]["output"]>;
  minSampleSize: Maybe<Scalars["Float"]["output"]>;
  totalCount: Maybe<Scalars["Int"]["output"]>;
};

export type IcpIndustryDistributionResult = {
  __typename?: "IcpIndustryDistributionResult";
  count: Maybe<Scalars["Int"]["output"]>;
  industryId: Maybe<Scalars["Int"]["output"]>;
  isSignificant: Maybe<Scalars["Int"]["output"]>;
  /** The share of the distribution that this industry represents. */
  share: Maybe<Scalars["Float"]["output"]>;
};

export type IcpIndustryWinLossResult = {
  __typename?: "IcpIndustryWinLossResult";
  countLost: Maybe<Scalars["Int"]["output"]>;
  countWon: Maybe<Scalars["Int"]["output"]>;
  industryId: Maybe<Scalars["Int"]["output"]>;
  isSignificant: Maybe<Scalars["Int"]["output"]>;
  minSampleSize: Maybe<Scalars["Float"]["output"]>;
  totalCount: Maybe<Scalars["Int"]["output"]>;
};

export type IcpRevenueDistributionResult = {
  __typename?: "IcpRevenueDistributionResult";
  count: Maybe<Scalars["Int"]["output"]>;
  isSignificant: Maybe<Scalars["Int"]["output"]>;
  revenueRange: Maybe<Scalars["String"]["output"]>;
  revenueRangeMax: Maybe<Scalars["Int"]["output"]>;
  revenueRangeMin: Maybe<Scalars["Int"]["output"]>;
  /** The share of the distribution that this revenue band represents. */
  share: Maybe<Scalars["Float"]["output"]>;
};

export type IcpRevenueRangeWinLossResult = {
  __typename?: "IcpRevenueRangeWinLossResult";
  countLost: Maybe<Scalars["Int"]["output"]>;
  countWon: Maybe<Scalars["Int"]["output"]>;
  isSignificant: Maybe<Scalars["Int"]["output"]>;
  minSampleSize: Maybe<Scalars["Float"]["output"]>;
  revenueRange: Maybe<Scalars["String"]["output"]>;
  revenueRangeMax: Maybe<Scalars["Int"]["output"]>;
  revenueRangeMin: Maybe<Scalars["Int"]["output"]>;
  totalCount: Maybe<Scalars["Int"]["output"]>;
};

export type IdentInclusionFilter = {
  ids: Array<InputMaybe<Scalars["Identifier"]["input"]>>;
  inclusionMethod?: InputMaybe<InclusionMethod>;
};

export type InclusionFilter = {
  ids: Array<InputMaybe<Scalars["Int"]["input"]>>;
  inclusionMethod?: InputMaybe<InclusionMethod>;
};

export enum InclusionMethod {
  ALL_PRESENT = "ALL_PRESENT",
  ANY_PRESENT = "ANY_PRESENT",
  NONE_PRESENT = "NONE_PRESENT",
}

export enum InclusionType {
  ALL = "ALL",
  FILTERS = "FILTERS",
  NONE = "NONE",
  SELECTED = "SELECTED",
}

export type Industry = {
  __typename?: "Industry";
  id: Maybe<Scalars["String"]["output"]>;
  name: Maybe<Scalars["String"]["output"]>;
};

export type IndustryFilter = {
  excludedIndustryIds?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  excludedNaics2012Ids?: InputMaybe<
    Array<InputMaybe<Scalars["Identifier"]["input"]>>
  >;
  excludedSicUs1987Ids?: InputMaybe<
    Array<InputMaybe<Scalars["Identifier"]["input"]>>
  >;
  /** include_null is no longer supported */
  includeNull?: InputMaybe<Scalars["Boolean"]["input"]>;
  industryIds?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  naics2012Ids?: InputMaybe<Array<InputMaybe<Scalars["Identifier"]["input"]>>>;
  sicUs1987Ids?: InputMaybe<Array<InputMaybe<Scalars["Identifier"]["input"]>>>;
};

export type IndustryScore = {
  /** include_null is no longer supported */
  includeNull?: InputMaybe<Scalars["Boolean"]["input"]>;
  industryIds?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  naics2012Ids?: InputMaybe<Array<InputMaybe<Scalars["Identifier"]["input"]>>>;
  score?: Scalars["Int"]["input"];
  sicUs1987Ids?: InputMaybe<Array<InputMaybe<Scalars["Identifier"]["input"]>>>;
};

export type IndustrySpendBreakdown = {
  __typename?: "IndustrySpendBreakdown";
  companyCount: Maybe<Scalars["Int"]["output"]>;
  industryId: Maybe<Scalars["Int"]["output"]>;
  totalSpend: Maybe<Scalars["Int"]["output"]>;
};

export type InputIntegerRange = {
  max?: InputMaybe<Scalars["Int"]["input"]>;
  min?: InputMaybe<Scalars["Int"]["input"]>;
};

export type Install = {
  __typename?: "Install";
  companyCount: Maybe<Scalars["Int"]["output"]>;
  companyGroupId: Maybe<Scalars["Identifier"]["output"]>;
  firstVerified: Maybe<Scalars["Date"]["output"]>;
  hgId: Maybe<Scalars["Identifier"]["output"]>;
  hgIdAny: Maybe<Scalars["Identifier"]["output"]>;
  intensity: Maybe<Scalars["Int"]["output"]>;
  lastVerified: Maybe<Scalars["Date"]["output"]>;
  location: Maybe<Geo>;
  locations: Maybe<Scalars["Int"]["output"]>;
  product: Maybe<Product>;
  products: Maybe<Scalars["Int"]["output"]>;
  url: Maybe<Scalars["String"]["output"]>;
};

export type InstallCategoryVendorCount = {
  __typename?: "InstallCategoryVendorCount";
  category: Maybe<ProductCategory>;
  hgId: Maybe<Scalars["Identifier"]["output"]>;
  vendorCount: Maybe<Scalars["Int"]["output"]>;
};

export type InstallCategoryVendorCountData = {
  __typename?: "InstallCategoryVendorCountData";
  count: Maybe<Scalars["Int"]["output"]>;
  data: Maybe<Array<Maybe<InstallCategoryVendorCount>>>;
};

export type InstallData = {
  __typename?: "InstallData";
  count: Maybe<Scalars["Int"]["output"]>;
  data: Maybe<Array<Maybe<Install>>>;
};

export type InstallVendorProductCount = {
  __typename?: "InstallVendorProductCount";
  hgId: Maybe<Scalars["Identifier"]["output"]>;
  productCount: Maybe<Scalars["Int"]["output"]>;
  vendor: Maybe<Vendor>;
};

export type InstallVendorProductCountData = {
  __typename?: "InstallVendorProductCountData";
  count: Maybe<Scalars["Int"]["output"]>;
  data: Maybe<Array<Maybe<InstallVendorProductCount>>>;
};

export type IntegerRange = {
  __typename?: "IntegerRange";
  max: Maybe<Scalars["Int"]["output"]>;
  min: Maybe<Scalars["Int"]["output"]>;
};

export type IntegerRangeSpendBreakdown = {
  __typename?: "IntegerRangeSpendBreakdown";
  companyCount: Maybe<Scalars["Int"]["output"]>;
  range: Maybe<IntegerRange>;
  totalSpend: Maybe<Scalars["Int"]["output"]>;
};

export type IntensityMomentumPayload = {
  __typename?: "IntensityMomentumPayload";
  count: Maybe<Scalars["Int"]["output"]>;
  data: Maybe<Array<Maybe<IntensityMomentumResult>>>;
};

export type IntensityMomentumResult = {
  __typename?: "IntensityMomentumResult";
  productName: Maybe<Scalars["String"]["output"]>;
  value: Maybe<Scalars["Float"]["output"]>;
  vendorUrl: Maybe<Scalars["String"]["output"]>;
};

export type IntensityOverTimeResult = {
  __typename?: "IntensityOverTimeResult";
  productName: Maybe<Scalars["String"]["output"]>;
  trend: Maybe<ProductScore>;
};

export type IntensityTrend = {
  __typename?: "IntensityTrend";
  product: Maybe<ProductTrend>;
  trend: Maybe<ProductScore>;
};

export type IntensityTrendPayload = {
  __typename?: "IntensityTrendPayload";
  count: Maybe<Scalars["Int"]["output"]>;
  data: Maybe<Array<Maybe<IntensityTrendResult>>>;
};

export type IntensityTrendResult = {
  __typename?: "IntensityTrendResult";
  productName: Maybe<Scalars["String"]["output"]>;
  value: Maybe<Scalars["Float"]["output"]>;
  vendorUrl: Maybe<Scalars["String"]["output"]>;
};

export type Intent = {
  __typename?: "Intent";
  buyersJourney: Maybe<IntentBuyersJourney>;
  contextAggregate: Maybe<ContextAggregate>;
  lastSeenAt: Maybe<Scalars["Date"]["output"]>;
  location: Maybe<GeoRange>;
  locationScore: Maybe<Scalars["Int"]["output"]>;
  score: Maybe<Scalars["Int"]["output"]>;
  topic: Maybe<IntentTopic>;
  trend: Maybe<Scalars["Float"]["output"]>;
  url: Maybe<Scalars["String"]["output"]>;
  urlId: Maybe<Scalars["Identifier"]["output"]>;
};

export type IntentBuyersJourney = {
  __typename?: "IntentBuyersJourney";
  id: Maybe<Scalars["Identifier"]["output"]>;
  name: Maybe<Scalars["String"]["output"]>;
};

export type IntentContext = {
  __typename?: "IntentContext";
  contextType: Maybe<IntentContextType>;
  hgId: Maybe<Scalars["Identifier"]["output"]>;
  id: Maybe<Scalars["Identifier"]["output"]>;
  productName: Maybe<Scalars["String"]["output"]>;
  topicId: Maybe<Scalars["Identifier"]["output"]>;
  vendorName: Maybe<Scalars["String"]["output"]>;
};

export type IntentContextData = {
  __typename?: "IntentContextData";
  count: Maybe<Scalars["Int"]["output"]>;
  data: Maybe<Array<Maybe<IntentContext>>>;
};

export type IntentContextType = {
  __typename?: "IntentContextType";
  id: Maybe<Scalars["Identifier"]["output"]>;
  name: Maybe<Scalars["String"]["output"]>;
};

export type IntentData = {
  __typename?: "IntentData";
  count: Maybe<Scalars["Int"]["output"]>;
  data: Maybe<Array<Maybe<Intent>>>;
};

export type IntentFilter = {
  buyersJourneyIds?: InputMaybe<
    Array<InputMaybe<Scalars["Identifier"]["input"]>>
  >;
  contextTypeIds?: InputMaybe<
    Array<InputMaybe<Scalars["Identifier"]["input"]>>
  >;
  /** include_null is no longer supported */
  includeNull?: InputMaybe<Scalars["Boolean"]["input"]>;
  location?: InputMaybe<LocationFilter>;
  numberOfCadences?: InputMaybe<Scalars["Int"]["input"]>;
  signalScore?: InputMaybe<SignalScore>;
  topics: IdentInclusionFilter;
};

export type IntentTopic = {
  __typename?: "IntentTopic";
  category: Maybe<Scalars["String"]["output"]>;
  displayName: Maybe<Scalars["String"]["output"]>;
  id: Maybe<Scalars["Identifier"]["output"]>;
  name: Maybe<Scalars["String"]["output"]>;
};

export enum KnownCompaniesInclusionMethod {
  ANY_PRESENT = "ANY_PRESENT",
  NONE_PRESENT = "NONE_PRESENT",
}

export type KnownCompaniesFilter = {
  fileName?: InputMaybe<Scalars["String"]["input"]>;
  identifier: Scalars["String"]["input"];
  includeHierarchy?: InputMaybe<Scalars["Boolean"]["input"]>;
  inclusionMethod?: InputMaybe<KnownCompaniesInclusionMethod>;
  invalidRows?: InputMaybe<Scalars["Int"]["input"]>;
  matchedRows?: InputMaybe<Scalars["Int"]["input"]>;
  totalRows?: InputMaybe<Scalars["Int"]["input"]>;
  uploaded?: InputMaybe<Scalars["DateTime"]["input"]>;
  validRows?: InputMaybe<Scalars["Int"]["input"]>;
};

export type KnownCompaniesUpload = {
  __typename?: "KnownCompaniesUpload";
  error: Maybe<Scalars["String"]["output"]>;
  identifier: Scalars["String"]["output"];
  invalidRows: Maybe<Scalars["Int"]["output"]>;
  matchedRows: Maybe<Scalars["Int"]["output"]>;
  status: KnownCompaniesUploadStatus;
  totalRows: Maybe<Scalars["Int"]["output"]>;
  validRows: Maybe<Scalars["Int"]["output"]>;
};

export enum KnownCompaniesUploadStatus {
  ERROR = "ERROR",
  PROCESSING = "PROCESSING",
  SUCCESS = "SUCCESS",
}

export type LocationFilter = {
  countryAlpha2s?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  excludedCountryAlpha2s?: InputMaybe<
    Array<InputMaybe<Scalars["String"]["input"]>>
  >;
  regionNames?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  stateIds?: InputMaybe<Array<InputMaybe<Scalars["Identifier"]["input"]>>>;
};

export type LocationScore = {
  countryAlpha2s?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  regionNames?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  score?: Scalars["Int"]["input"];
  stateIds?: InputMaybe<Array<InputMaybe<Scalars["Identifier"]["input"]>>>;
};

export type MarketBreakdown = {
  __typename?: "MarketBreakdown";
  companyCount: Maybe<Scalars["Int"]["output"]>;
  totalSpend: Maybe<Scalars["Int"]["output"]>;
};

export type MarketPenetrationOverTimeResult = {
  __typename?: "MarketPenetrationOverTimeResult";
  companyCount: Maybe<Scalars["Int"]["output"]>;
  marketCount: Maybe<Scalars["Int"]["output"]>;
  monthStartDate: Maybe<Scalars["String"]["output"]>;
  productId: Maybe<Scalars["Int"]["output"]>;
};

export type MarketPenetrationResult = {
  __typename?: "MarketPenetrationResult";
  companyCount: Maybe<Scalars["Int"]["output"]>;
  productId: Maybe<Scalars["Int"]["output"]>;
};

export type MarketTimeSeriesAttributeBreakdown = {
  __typename?: "MarketTimeSeriesAttributeBreakdown";
  attributeId: Maybe<Scalars["Int"]["output"]>;
  hits: Maybe<Scalars["Int"]["output"]>;
  monthStartDate: Maybe<Scalars["Date"]["output"]>;
};

export type MarketTimeSeriesCategoryBreakdown = {
  __typename?: "MarketTimeSeriesCategoryBreakdown";
  categoryId: Maybe<Scalars["Identifier"]["output"]>;
  hits: Maybe<Scalars["Int"]["output"]>;
  monthStartDate: Maybe<Scalars["Date"]["output"]>;
};

export enum MarketTimeSeriesMetric {
  FIRST_VERIFIED = "FIRST_VERIFIED",
}

export enum MarketTimeSeriesPeriod {
  MONTH = "MONTH",
  QUARTER = "QUARTER",
  YEAR = "YEAR",
}

export type MarketTimeSeriesProductBreakdown = {
  __typename?: "MarketTimeSeriesProductBreakdown";
  hits: Maybe<Scalars["Int"]["output"]>;
  monthStartDate: Maybe<Scalars["Date"]["output"]>;
  productId: Maybe<Scalars["Int"]["output"]>;
};

export type MarketTimeSeriesVendorBreakdown = {
  __typename?: "MarketTimeSeriesVendorBreakdown";
  hits: Maybe<Scalars["Int"]["output"]>;
  monthStartDate: Maybe<Scalars["Date"]["output"]>;
  vendorId: Maybe<Scalars["Int"]["output"]>;
};

export type MinMaxFilter = {
  /** include_null is no longer supported */
  includeNull?: InputMaybe<Scalars["Boolean"]["input"]>;
  max?: InputMaybe<Scalars["Int"]["input"]>;
  min?: InputMaybe<Scalars["Int"]["input"]>;
};

export type MinMaxScore = {
  max?: InputMaybe<Scalars["Int"]["input"]>;
  min?: InputMaybe<Scalars["Int"]["input"]>;
  score?: Scalars["Int"]["input"];
};

export type Naics2012 = {
  __typename?: "Naics2012";
  code: Maybe<Scalars["String"]["output"]>;
  id: Maybe<Scalars["Identifier"]["output"]>;
  name: Maybe<Scalars["String"]["output"]>;
  parentId: Maybe<Scalars["Identifier"]["output"]>;
  topLevelParent: Maybe<TopParentNaics2012>;
};

export type Naics2012Agg = {
  __typename?: "Naics2012Agg";
  code: Maybe<Scalars["String"]["output"]>;
  name: Maybe<Scalars["String"]["output"]>;
  topLevelParent: Maybe<TopParentNaics2012Agg>;
};

export type NaicsSpendBreakdown = {
  __typename?: "NaicsSpendBreakdown";
  companyCount: Maybe<Scalars["Int"]["output"]>;
  naicsId: Maybe<Scalars["Identifier"]["output"]>;
  totalSpend: Maybe<Scalars["Int"]["output"]>;
};

export type OpportunityGeneratorFilter = {
  buyerIntentAttributes?: InputMaybe<BuyerIntentAttributeFilter>;
  buyerIntentCategories?: InputMaybe<BuyerIntentCategoryFilter>;
  buyerIntentProducts?: InputMaybe<Array<InputMaybe<BuyerIntentProductFilter>>>;
  buyerIntentVendors?: InputMaybe<Array<InputMaybe<BuyerIntentVendorFilter>>>;
  companyMatch?: InputMaybe<CompanyMatchFilter>;
  companyPromotionDate?: InputMaybe<CompanyPromotionDateFilter>;
  countryAlpha2s?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars["Identifier"]["input"]>>>;
  duns?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  employees?: InputMaybe<MinMaxFilter>;
  excludedCountryAlpha2s?: InputMaybe<
    Array<InputMaybe<Scalars["String"]["input"]>>
  >;
  fitScore?: InputMaybe<MinMaxFilter>;
  forbes2000?: InputMaybe<Scalars["Boolean"]["input"]>;
  fortune500?: InputMaybe<Scalars["Boolean"]["input"]>;
  fuzzySearch?: InputMaybe<Scalars["String"]["input"]>;
  globalPresence?: InputMaybe<GlobalPresenceFilter>;
  hasFinancingEvent?: InputMaybe<HasFinancingEventFilter>;
  hasFixedEmployees?: InputMaybe<Scalars["Boolean"]["input"]>;
  hasFixedRevenue?: InputMaybe<Scalars["Boolean"]["input"]>;
  hgIds?: InputMaybe<Array<InputMaybe<Scalars["Identifier"]["input"]>>>;
  hgIdsIncludingCorporateRelatives?: InputMaybe<
    Array<InputMaybe<Scalars["Identifier"]["input"]>>
  >;
  hgIdsTables?: InputMaybe<Array<InputMaybe<TableFilter>>>;
  includeDecisionMakersAndInfluencersOnly?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  industry?: InputMaybe<IndustryFilter>;
  intent?: InputMaybe<IntentFilter>;
  intentScore?: InputMaybe<MinMaxFilter>;
  isDp?: InputMaybe<Scalars["Boolean"]["input"]>;
  isDu?: InputMaybe<Scalars["Boolean"]["input"]>;
  isGhq?: InputMaybe<Scalars["Boolean"]["input"]>;
  isGp?: InputMaybe<Scalars["Boolean"]["input"]>;
  isGu?: InputMaybe<Scalars["Boolean"]["input"]>;
  knownCompanies?: InputMaybe<KnownCompaniesFilter>;
  opportunityType?: InputMaybe<OpportunityTypeFilter>;
  productAttributeIds?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  productAttributes?: InputMaybe<ProductAttributeFilter>;
  productCategories?: InputMaybe<ProductCategoryFilter>;
  productCategoryIds?: InputMaybe<
    Array<InputMaybe<Scalars["Identifier"]["input"]>>
  >;
  products?: InputMaybe<Array<InputMaybe<ProductFilter>>>;
  regionNames?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  revenue?: InputMaybe<MinMaxFilter>;
  roleIds?: InputMaybe<Array<InputMaybe<Scalars["Identifier"]["input"]>>>;
  spend?: InputMaybe<Array<InputMaybe<SpendFilter>>>;
  stateIds?: InputMaybe<Array<InputMaybe<Scalars["Identifier"]["input"]>>>;
  vendors?: InputMaybe<Array<InputMaybe<VendorFilter>>>;
  whitespace?: InputMaybe<WhitespaceFilter>;
};

export type OpportunityGeneratorScoringProfileSalesplaySearch = {
  /** A 'hack' to make FE not to use apollo cache when only localize_installs settings is updated for the scoring profile */
  localizeInstallsForProfile?: InputMaybe<Scalars["Boolean"]["input"]>;
  order: Scalars["Int"]["input"];
  scoringCriteria?: InputMaybe<Array<InputMaybe<ScoringProfile>>>;
  scoringProfileId: Scalars["Int"]["input"];
};

export type OpportunityGeneratorSearch = {
  __typename?: "OpportunityGeneratorSearch";
  competitorPresence: Maybe<Array<Maybe<Scalars["Int"]["output"]>>>;
  countryName: Maybe<Scalars["String"]["output"]>;
  duns: Maybe<Scalars["String"]["output"]>;
  employeeRange: Maybe<FirmoRange>;
  hgId: Maybe<Scalars["Identifier"]["output"]>;
  isDp: Maybe<Scalars["Boolean"]["output"]>;
  isExpansionWhitespace: Maybe<Scalars["Int"]["output"]>;
  isGhq: Maybe<Scalars["Boolean"]["output"]>;
  isGp: Maybe<Scalars["Boolean"]["output"]>;
  isProspectWhitespace: Maybe<Scalars["Int"]["output"]>;
  isWhitespace: Maybe<Scalars["Int"]["output"]>;
  itSpend: Maybe<Scalars["Int"]["output"]>;
  modelScores: Maybe<Scalars["RawJson"]["output"]>;
  name: Maybe<Scalars["String"]["output"]>;
  revenueRange: Maybe<FirmoRange>;
  scores: Maybe<Scalars["RawJson"]["output"]>;
  url: Maybe<Scalars["String"]["output"]>;
};

export type OpportunityGeneratorSearchData = {
  __typename?: "OpportunityGeneratorSearchData";
  arguments: Maybe<Array<Maybe<Scalars["Any"]["output"]>>>;
  count: Maybe<Scalars["Int"]["output"]>;
  data: Maybe<Array<Maybe<OpportunityGeneratorSearch>>>;
  queryBrokerFilter: Maybe<Scalars["RawJson"]["output"]>;
  statement: Maybe<Scalars["String"]["output"]>;
};

export enum OpportunityType {
  CUSTOMER = "CUSTOMER",
  EXPANSION_WHITESPACE = "EXPANSION_WHITESPACE",
  PROSPECT_WHITESPACE = "PROSPECT_WHITESPACE",
  WHITESPACE = "WHITESPACE",
}

export type OpportunityTypeFilter = {
  type?: InputMaybe<OpportunityType>;
};

export type OrgTree = {
  __typename?: "OrgTree";
  descendants: Maybe<Array<Maybe<Scalars["Identifier"]["output"]>>>;
  root: Maybe<Scalars["Identifier"]["output"]>;
};

export type ParentCompany = {
  __typename?: "ParentCompany";
  address: Maybe<Address>;
  employeeRange: Maybe<FirmoRange>;
  forbes2000: Maybe<Scalars["Int"]["output"]>;
  fortune500: Maybe<Scalars["Int"]["output"]>;
  hgId: Maybe<Scalars["Identifier"]["output"]>;
  industry: Maybe<Industry>;
  latitude: Maybe<Scalars["Float"]["output"]>;
  locationPrimary: Maybe<Geo>;
  longitude: Maybe<Scalars["Float"]["output"]>;
  name: Maybe<Scalars["String"]["output"]>;
  revenueRange: Maybe<FirmoRange>;
  url: Maybe<Scalars["String"]["output"]>;
  urlInstall: Maybe<Scalars["String"]["output"]>;
};

export type PresenceByDepartmentResult = {
  __typename?: "PresenceByDepartmentResult";
  faiDepartmentId: Maybe<Scalars["Identifier"]["output"]>;
  faiDepartmentName: Maybe<Scalars["String"]["output"]>;
  installsCount: Maybe<Scalars["Int"]["output"]>;
};

export type Product = {
  __typename?: "Product";
  attributeNames: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  category: Maybe<ProductCategory>;
  description: Maybe<Scalars["String"]["output"]>;
  id: Maybe<Scalars["Int"]["output"]>;
  name: Maybe<Scalars["String"]["output"]>;
  vendor: Maybe<Vendor>;
};

export type ProductAttributeFilter = {
  ids: Array<InputMaybe<Scalars["Int"]["input"]>>;
  installAge?: InputMaybe<MinMaxFilter>;
  installAgeMonths?: InputMaybe<MinMaxFilter>;
};

export type ProductCatalogInstallsCountResult = {
  __typename?: "ProductCatalogInstallsCountResult";
  count: Maybe<Scalars["Int"]["output"]>;
};

export type ProductCatalogInstallsProductsResult = {
  __typename?: "ProductCatalogInstallsProductsResult";
  companyCount: Maybe<Scalars["Int"]["output"]>;
  productId: Maybe<Scalars["Int"]["output"]>;
  productName: Maybe<Scalars["String"]["output"]>;
};

export type ProductCategory = {
  __typename?: "ProductCategory";
  code: Maybe<Scalars["String"]["output"]>;
  id: Maybe<Scalars["Identifier"]["output"]>;
  name: Maybe<Scalars["String"]["output"]>;
  nameTree: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  parentId: Maybe<Scalars["Identifier"]["output"]>;
};

export type ProductCategoryFilter = {
  /** FAI Departments */
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars["Identifier"]["input"]>>>;
  ids: Array<InputMaybe<Scalars["Identifier"]["input"]>>;
  installAge?: InputMaybe<MinMaxFilter>;
  installAgeMonths?: InputMaybe<MinMaxFilter>;
  /** FAI Role */
  roleIds?: InputMaybe<Array<InputMaybe<Scalars["Identifier"]["input"]>>>;
};

export enum ProductDetectionSegments {
  COUNTRY = "COUNTRY",
  EMPLOYEE = "EMPLOYEE",
  INDUSTRY = "INDUSTRY",
  INDUSTRY_NAICS = "INDUSTRY_NAICS",
  REGION = "REGION",
  REVENUE = "REVENUE",
}

export type ProductDetectionsBySegmentResult = {
  __typename?: "ProductDetectionsBySegmentResult";
  hits: Maybe<Scalars["Int"]["output"]>;
  productId: Maybe<Scalars["Int"]["output"]>;
  segment: Maybe<Scalars["StringOrIntegerRange"]["output"]>;
};

export type ProductFilter = {
  collectionId?: InputMaybe<Scalars["String"]["input"]>;
  /** FAI Departments */
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars["Identifier"]["input"]>>>;
  ids: Array<InputMaybe<Scalars["Int"]["input"]>>;
  inclusionMethod?: InputMaybe<InclusionMethod>;
  installAge?: InputMaybe<MinMaxFilter>;
  installAgeMonths?: InputMaybe<MinMaxFilter>;
  intensity?: InputMaybe<MinMaxFilter>;
  /** FAI Role */
  roleIds?: InputMaybe<Array<InputMaybe<Scalars["Identifier"]["input"]>>>;
  type?: InputMaybe<Scalars["String"]["input"]>;
};

export type ProductInstallAgeMinMaxScore = {
  max?: InputMaybe<Scalars["Int"]["input"]>;
  min?: InputMaybe<Scalars["Int"]["input"]>;
  productIds: Array<InputMaybe<Scalars["Int"]["input"]>>;
  score?: Scalars["Int"]["input"];
};

export type ProductIntensityScore = {
  max?: InputMaybe<Scalars["Int"]["input"]>;
  min?: InputMaybe<Scalars["Int"]["input"]>;
  productIds?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  score?: Scalars["Int"]["input"];
};

export type ProductPresenceScore = {
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars["Identifier"]["input"]>>>;
  ids: Array<InputMaybe<Scalars["Int"]["input"]>>;
  inclusionMethod: InclusionMethod;
  roleIds?: InputMaybe<Array<InputMaybe<Scalars["Identifier"]["input"]>>>;
  score?: Scalars["Int"]["input"];
};

export type ProductScore = {
  __typename?: "ProductScore";
  month: Maybe<Scalars["Int"]["output"]>;
  quarter: Maybe<Scalars["Int"]["output"]>;
  score: Maybe<Scalars["Float"]["output"]>;
  year: Maybe<Scalars["Int"]["output"]>;
};

export type ProductTrend = {
  __typename?: "ProductTrend";
  category: Maybe<ProductCategory>;
  date: Maybe<Scalars["Date"]["output"]>;
  description: Maybe<Scalars["String"]["output"]>;
  id: Maybe<Scalars["Int"]["output"]>;
  intensity: Maybe<Scalars["Int"]["output"]>;
  intensityMomentum: Maybe<Scalars["Int"]["output"]>;
  intensityTrend: Maybe<Scalars["Int"]["output"]>;
  name: Maybe<Scalars["String"]["output"]>;
  vendor: Maybe<Vendor>;
};

export type ProductTrendData = {
  __typename?: "ProductTrendData";
  count: Maybe<Scalars["Int"]["output"]>;
  data: Maybe<Array<Maybe<IntensityTrend>>>;
};

export type RecentInstallsResult = {
  __typename?: "RecentInstallsResult";
  companyName: Maybe<Scalars["String"]["output"]>;
  companyUrl: Maybe<Scalars["String"]["output"]>;
  firstVerified: Maybe<Scalars["String"]["output"]>;
  intensity: Maybe<Scalars["Int"]["output"]>;
  productId: Maybe<Scalars["Int"]["output"]>;
  productName: Maybe<Scalars["String"]["output"]>;
  revenueMax: Maybe<Scalars["Int"]["output"]>;
  revenueMin: Maybe<Scalars["Int"]["output"]>;
  vendorUrl: Maybe<Scalars["String"]["output"]>;
};

export type Region = {
  __typename?: "Region";
  id: Maybe<Scalars["Identifier"]["output"]>;
  name: Maybe<Scalars["String"]["output"]>;
};

export enum RegionNames {
  AMER = "AMER",
  APAC = "APAC",
  EMEA = "EMEA",
}

export type RootMutationType = {
  __typename?: "RootMutationType";
  /** Create or Update an Opportunity Generator scoring table */
  createOpportunityGeneratorScoringTable: Maybe<SqlObjectResponse>;
  /** Drop an Opportunity Generator scoring table */
  dropOpportunityGeneratorScoringTable: Maybe<SqlObjectResponse>;
  /** Upload a CSV of HG IDs for the Known Companies filter (SuperKudu only) */
  uploadKnownCompanies: Maybe<KnownCompaniesUpload>;
};

export type RootMutationTypeCreateOpportunityGeneratorScoringTableArgs = {
  companyMatchFile?: InputMaybe<CompanyMatchFilter>;
  installAge?: InputMaybe<Scalars["Int"]["input"]>;
  localizeInstalls?: InputMaybe<Scalars["Boolean"]["input"]>;
  scoringCriteria: Array<InputMaybe<ScoringProfile>>;
  scoringProfileId: Scalars["Int"]["input"];
};

export type RootMutationTypeDropOpportunityGeneratorScoringTableArgs = {
  scoringProfileId: Scalars["Int"]["input"];
};

export type RootMutationTypeUploadKnownCompaniesArgs = {
  columnCount: Scalars["Int"]["input"];
  columnIndex: Scalars["Int"]["input"];
  file: Scalars["Upload"]["input"];
  hasHeader: Scalars["Boolean"]["input"];
};

export type RootQueryTypeKnownCompaniesUploadArgs = {
  identifier: Scalars["String"]["input"];
};

export type RootQueryType = {
  __typename?: "RootQueryType";
  /** Processing status of a Known Companies upload (SuperKudu only) */
  knownCompaniesUpload: Maybe<KnownCompaniesUpload>;
  /** Check whether an Opportunity Generator Scoring Profile is ready yet */
  checkOpportunityGeneratorScoringTableReady: Maybe<ScoringTableReady>;
  /** Check 'ready' status for multiple Opportunity Generator Scoring Profiles */
  checkOpportunityGeneratorScoringTablesStatus: Maybe<ScoringTablesStatusData>;
  /** Search for cloud maturity data by urlId as a single parameter, optionally providing page & sort details */
  cloudMaturity: Maybe<CloudMaturityData>;
  /** Find company location by id */
  company: Maybe<CompanyLocationsData>;
  /** Find company by id */
  companyCompany: Maybe<CompanyData>;
  companyProfileRowCountCheck: Maybe<ExportRowCountData>;
  /** Search for contract data by hgId as a single parameter, optionally providing page & sort details */
  contract: Maybe<ContractData>;
  /** Search for contract data by hgId as a single parameter, optionally providing page & sort details */
  contractRowCount: Maybe<ContractData>;
  /** File URL for a given base64url encoded slug */
  fileDownload: Maybe<File>;
  /** Retrieve FAI data by Product */
  functionalAreaIntelligenceByCompany: Maybe<FunctionalAreaIntelligenceByCompanyData>;
  /** Functional Area Intelligence records on the granularity of companies. Location specific data is summed. */
  functionalAreaIntelligenceByUrl: Maybe<FunctionalAreaIntelligenceByUrlData>;
  /** Functional Area Intelligence records granular on location. */
  functionalIntelligenceByLocation: Maybe<FunctionalIntelligenceByLocationData>;
  /** Functional Area Intelligence records granular on location. */
  functionalIntelligenceLocation: Maybe<FunctionalIntelligenceLocationData>;
  /** Functional Area Intelligence records on the granularity of companies. Location specific data is summed. */
  functionalIntelligenceSummary: Maybe<FunctionalIntelligenceSummaryData>;
  globalMarketAnalysisCountryBreakdown: Maybe<
    Array<Maybe<CountrySpendBreakdown>>
  >;
  globalMarketAnalysisGeopoliticalRegionBreakdown: Maybe<
    Array<Maybe<GeopoliticalRegionSpendBreakdown>>
  >;
  /** Custom category not supported - use totalMarketSummary for the custom category view of this chart instead. */
  globalMarketAnalysisSpendCategoryBreakdown: Maybe<
    Array<Maybe<SpendCategorySpendBreakdown>>
  >;
  /** ICP Employee Count Distribution by product ids or company match file. */
  icpEmployeeCountDistribution: Maybe<
    Array<Maybe<IcpEmployeeCountDistributionResult>>
  >;
  icpEmployeeCountWinLossDistribution: Maybe<
    Array<Maybe<IcpEmployeeRangeWinLossResult>>
  >;
  /** ICP Geography Distribution by product ids or company match file. */
  icpGeographyDistribution: Maybe<Array<Maybe<IcpGeographyDistributionResult>>>;
  icpGeographyWinLossDistribution: Maybe<
    Array<Maybe<IcpGeographyWinLossResult>>
  >;
  /** ICP Industry Distribution by product ids or company match file. */
  icpIndustryDistribution: Maybe<Array<Maybe<IcpIndustryDistributionResult>>>;
  /** ICP Revenue Distribution by product ids or company match file. */
  icpRevenueDistribution: Maybe<Array<Maybe<IcpRevenueDistributionResult>>>;
  icpRevenueWinLossDistribution: Maybe<
    Array<Maybe<IcpRevenueRangeWinLossResult>>
  >;
  /** ICP Industry Distribution by product ids or company match file. */
  icpWinLossIndustryDistribution: Maybe<Array<Maybe<IcpIndustryWinLossResult>>>;
  /** Search for install data by hgId as a single parameter, optionally providing page & sort details */
  install: Maybe<InstallData>;
  /**
   * Search for installed product count by vendor for a set of companies
   * @deprecated Use `topVendorsByProductCount` instead. Being replaced due to buggy SQL.
   */
  installProductCountByVendor: Maybe<InstallVendorProductCountData>;
  /** Get installed vendor count by category for hgId as a single parameter, optionally providing filter, page & sort details */
  installVendorCountByCategory: Maybe<InstallCategoryVendorCountData>;
  /** Search for install data by multiple hgIds, vendors, categories, company filters and/or products, optionally providing page & sort details */
  installs: Maybe<InstallData>;
  intensityMomentum: Maybe<IntensityMomentumPayload>;
  intensityOverTime: Maybe<Array<Maybe<IntensityOverTimeResult>>>;
  intensityTrend: Maybe<IntensityTrendPayload>;
  /**
   * Search for intent signal data by multiple urls, optionally providing country, state, intent_topic, number of cadences
   *      and intent_context_type, optionally providing page & sort details
   */
  intent: Maybe<IntentData>;
  /** Search for intent context data by ids */
  intentContext: Maybe<IntentContextData>;
  /** Returns data to power Top Products chart. */
  marketPenetration: Maybe<Array<Maybe<MarketPenetrationResult>>>;
  /** Returns data to power Market Penetration Over Time chart. */
  marketPenetrationOverTime: Maybe<
    Array<Maybe<MarketPenetrationOverTimeResult>>
  >;
  /** Returns data to power Market Time Series by Product Attribute charts. */
  marketTimeSeriesProductAttributeBreakdown: Maybe<
    Array<Maybe<MarketTimeSeriesAttributeBreakdown>>
  >;
  /** Returns data to power Market Time Series by Product charts. */
  marketTimeSeriesProductBreakdown: Maybe<
    Array<Maybe<MarketTimeSeriesProductBreakdown>>
  >;
  /** Returns data to power Market Time Series by Product Categiry charts. */
  marketTimeSeriesProductCategoryBreakdown: Maybe<
    Array<Maybe<MarketTimeSeriesCategoryBreakdown>>
  >;
  /** Returns data to power Market Time Series by Vendor charts. */
  marketTimeSeriesVendorBreakdown: Maybe<
    Array<Maybe<MarketTimeSeriesVendorBreakdown>>
  >;
  /** Search, sort and paginate Opportunity Generator queries */
  opportunityGeneratorSearch: Maybe<OpportunityGeneratorSearchData>;
  /** Returns data to power Presence By Department chart. */
  presenceByDepartment: Maybe<Array<Maybe<PresenceByDepartmentResult>>>;
  productCatalogInstallsCount: Maybe<ProductCatalogInstallsCountResult>;
  productCatalogInstallsProducts: Maybe<
    Array<Maybe<ProductCatalogInstallsProductsResult>>
  >;
  productDetectionsBySegment: Maybe<
    Array<Maybe<ProductDetectionsBySegmentResult>>
  >;
  /** Search for product trend by hgId as a single parameter, optionally providing page, */
  productTrend: Maybe<ProductTrendData>;
  /** Returns data to power Recent Installs chart. */
  recentInstalls: Maybe<Array<Maybe<RecentInstallsResult>>>;
  /** Retrieve number of rows that will be contained in an export */
  rowCountCheck: Maybe<ExportRowCountData>;
  /** Build scoring profile human readable version */
  scoringProfileHumanReadableVersion: Maybe<ScoringProfileHumanReadable>;
  /** Search, sort and paginate company locations */
  search: Maybe<CompanyLocationsData>;
  /** Search, sort and paginate companies */
  searchCompanies: Maybe<CompanyData>;
  searchCompaniesV2: Maybe<CompanySearchResultsData>;
  /** Search company names and hgIds */
  searchCompanyNames: Maybe<CompanyLocationsData>;
  segmentAnalysisCountryBreakdown: Maybe<Array<Maybe<CountrySpendBreakdown>>>;
  segmentAnalysisEmployeeRangeBreakdown: Maybe<
    Array<Maybe<IntegerRangeSpendBreakdown>>
  >;
  segmentAnalysisIndustryBreakdown: Maybe<Array<Maybe<IndustrySpendBreakdown>>>;
  segmentAnalysisNaicsBreakdown: Maybe<Array<Maybe<NaicsSpendBreakdown>>>;
  segmentAnalysisRevenueRangeBreakdown: Maybe<
    Array<Maybe<IntegerRangeSpendBreakdown>>
  >;
  /** Search for spend data by multiple hgIds, optionally providing page & sort details */
  spend: Maybe<SpendData>;
  /** Returns data to power Market Intelligence Spend Dynamics. Supports all chart views. */
  spendDynamics: Maybe<Array<Maybe<SpendDynamicsBreakdown>>>;
  /** Returns data to power Market Intelligence Technology Market Share. Supports all chart views. */
  technologyMarketShare: Maybe<Array<Maybe<TechnologyMarketShareBreakdown>>>;
  /** Returns data to power Top Products chart. */
  topProducts: Maybe<Array<Maybe<TopProductsHit>>>;
  /** Returns data to power Top Vendor click through. */
  topProductsForVendor: Maybe<Array<Maybe<TopProductsForVendorHit>>>;
  /** Returns data to power Top Vendors chart. */
  topVendors: Maybe<Array<Maybe<TopVendorsHit>>>;
  /** Given a company, returns top vendors based on count of associated product installs */
  topVendorsByProductCount: Maybe<Array<Maybe<VendorProductCount>>>;
  /** Sum of spend in provided categories for all companies matching the provided filters. */
  totalMarketSummary: Maybe<MarketBreakdown>;
  vendorPresence: Maybe<VendorPresenceData>;
};

export type RootQueryTypeCheckOpportunityGeneratorScoringTableReadyArgs = {
  scoringProfileId: Scalars["Int"]["input"];
};

export type RootQueryTypeCheckOpportunityGeneratorScoringTablesStatusArgs = {
  scoringProfileIds: Array<InputMaybe<Scalars["Int"]["input"]>>;
};

export type RootQueryTypeCloudMaturityArgs = {
  companyMatchFile?: InputMaybe<CompanyMatchFilter>;
  hgIds?: InputMaybe<Array<InputMaybe<Scalars["Identifier"]["input"]>>>;
  installAge?: InputMaybe<Scalars["Int"]["input"]>;
  localizeInstalls?: InputMaybe<Scalars["Boolean"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  per?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type RootQueryTypeCompanyArgs = {
  hgId: Scalars["Identifier"]["input"];
  scoring?: InputMaybe<Array<InputMaybe<ScoringProfile>>>;
};

export type RootQueryTypeCompanyCompanyArgs = {
  hgId: Scalars["Identifier"]["input"];
  scoring?: InputMaybe<Array<InputMaybe<ScoringProfile>>>;
};

export type RootQueryTypeCompanyProfileRowCountCheckArgs = {
  hgId: Scalars["Identifier"]["input"];
  install?: InputMaybe<CompanyProfileInstallParams>;
  intent?: InputMaybe<CompanyProfileIntentParams>;
};

export type RootQueryTypeContractArgs = {
  companyFilters?: InputMaybe<CompanyFilter>;
  companyMatchFile?: InputMaybe<CompanyMatchFilter>;
  hgIds?: InputMaybe<Array<InputMaybe<Scalars["Identifier"]["input"]>>>;
  installAge?: InputMaybe<Scalars["Int"]["input"]>;
  localizeInstalls?: InputMaybe<Scalars["Boolean"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  per?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type RootQueryTypeContractRowCountArgs = {
  companyFilters?: InputMaybe<CompanyFilter>;
  companyMatchFile?: InputMaybe<CompanyMatchFilter>;
  hgIds?: InputMaybe<Array<InputMaybe<Scalars["Identifier"]["input"]>>>;
  installAge?: InputMaybe<Scalars["Int"]["input"]>;
  localizeInstalls?: InputMaybe<Scalars["Boolean"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  per?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type RootQueryTypeFileDownloadArgs = {
  slug: Scalars["String"]["input"];
};

export type RootQueryTypeFunctionalAreaIntelligenceByCompanyArgs = {
  countryAlpha2s?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  departmentId?: InputMaybe<Scalars["Identifier"]["input"]>;
  hgId: Scalars["Identifier"]["input"];
  page?: InputMaybe<Scalars["Int"]["input"]>;
  per?: InputMaybe<Scalars["Int"]["input"]>;
  productAttributeIds?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  productCategoryIds?: InputMaybe<
    Array<InputMaybe<Scalars["Identifier"]["input"]>>
  >;
  productIds?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  roleId?: InputMaybe<Scalars["Identifier"]["input"]>;
  sort?: InputMaybe<Array<InputMaybe<FunctionalAreaIntelligenceByCompanySort>>>;
  vendorIds?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
};

export type RootQueryTypeFunctionalAreaIntelligenceByUrlArgs = {
  countryAlpha2s?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  department?: InputMaybe<Scalars["String"]["input"]>;
  hgId: Scalars["Identifier"]["input"];
  page?: InputMaybe<Scalars["Int"]["input"]>;
  per?: InputMaybe<Scalars["Int"]["input"]>;
  productCategoryIds?: InputMaybe<
    Array<InputMaybe<Scalars["Identifier"]["input"]>>
  >;
  productId?: InputMaybe<Scalars["Int"]["input"]>;
  productIds?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  productSignalStrength?: InputMaybe<Scalars["Int"]["input"]>;
  sorts?: InputMaybe<Array<InputMaybe<FunctionalAreaIntelligenceByUrlSort>>>;
  vendorIds?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
};

export type RootQueryTypeFunctionalIntelligenceByLocationArgs = {
  department?: InputMaybe<Scalars["String"]["input"]>;
  departmentId?: InputMaybe<Scalars["Identifier"]["input"]>;
  functionalAreaRole?: InputMaybe<Scalars["String"]["input"]>;
  functionalAreaRoleId?: InputMaybe<Scalars["Identifier"]["input"]>;
  hgId: Scalars["Identifier"]["input"];
  page?: InputMaybe<Scalars["Int"]["input"]>;
  per?: InputMaybe<Scalars["Int"]["input"]>;
  productId: Scalars["Int"]["input"];
  sorts?: InputMaybe<
    Array<InputMaybe<FunctionalAreaIntelligenceByLocationSort>>
  >;
};

export type RootQueryTypeFunctionalIntelligenceLocationArgs = {
  department?: InputMaybe<Scalars["String"]["input"]>;
  hgId: Scalars["Identifier"]["input"];
  page?: InputMaybe<Scalars["Int"]["input"]>;
  per?: InputMaybe<Scalars["Int"]["input"]>;
  productId?: InputMaybe<Scalars["Int"]["input"]>;
  sortsV2?: InputMaybe<
    Array<InputMaybe<FunctionalAreaIntelligenceLocationSort>>
  >;
};

export type RootQueryTypeFunctionalIntelligenceSummaryArgs = {
  countryAlpha2s?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  department?: InputMaybe<Scalars["String"]["input"]>;
  hgId: Scalars["Identifier"]["input"];
  page?: InputMaybe<Scalars["Int"]["input"]>;
  per?: InputMaybe<Scalars["Int"]["input"]>;
  productCategoryIds?: InputMaybe<
    Array<InputMaybe<Scalars["Identifier"]["input"]>>
  >;
  productId?: InputMaybe<Scalars["Int"]["input"]>;
  productIds?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  productSignalStrength?: InputMaybe<Scalars["Int"]["input"]>;
  sortsV2?: InputMaybe<
    Array<InputMaybe<FunctionalAreaIntelligenceSummarySort>>
  >;
  vendorIds?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
};

export type RootQueryTypeGlobalMarketAnalysisCountryBreakdownArgs = {
  companyFilters?: InputMaybe<OpportunityGeneratorFilter>;
  companyMatchFile?: InputMaybe<CompanyMatchFilter>;
  customSpendCategory?: InputMaybe<CustomSpendCategory>;
  installAge?: InputMaybe<Scalars["Int"]["input"]>;
  localizeInstalls?: InputMaybe<Scalars["Boolean"]["input"]>;
  spendCategoryIds?: InputMaybe<
    Array<InputMaybe<Scalars["Identifier"]["input"]>>
  >;
};

export type RootQueryTypeGlobalMarketAnalysisGeopoliticalRegionBreakdownArgs = {
  companyFilters?: InputMaybe<OpportunityGeneratorFilter>;
  companyMatchFile?: InputMaybe<CompanyMatchFilter>;
  customSpendCategory?: InputMaybe<CustomSpendCategory>;
  installAge?: InputMaybe<Scalars["Int"]["input"]>;
  localizeInstalls?: InputMaybe<Scalars["Boolean"]["input"]>;
  spendCategoryIds?: InputMaybe<
    Array<InputMaybe<Scalars["Identifier"]["input"]>>
  >;
};

export type RootQueryTypeGlobalMarketAnalysisSpendCategoryBreakdownArgs = {
  companyFilters?: InputMaybe<OpportunityGeneratorFilter>;
  companyMatchFile?: InputMaybe<CompanyMatchFilter>;
  installAge?: InputMaybe<Scalars["Int"]["input"]>;
  localizeInstalls?: InputMaybe<Scalars["Boolean"]["input"]>;
  spendCategoryIds?: InputMaybe<
    Array<InputMaybe<Scalars["Identifier"]["input"]>>
  >;
};

export type RootQueryTypeIcpEmployeeCountDistributionArgs = {
  globalSettings?: InputMaybe<GlobalSettings>;
  matchFile?: InputMaybe<CompanyMatchFilter>;
  productIds?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
};

export type RootQueryTypeIcpEmployeeCountWinLossDistributionArgs = {
  globalSettings?: InputMaybe<GlobalSettings>;
  matchFile?: InputMaybe<CompanyMatchFilter>;
};

export type RootQueryTypeIcpGeographyDistributionArgs = {
  globalSettings?: InputMaybe<GlobalSettings>;
  matchFile?: InputMaybe<CompanyMatchFilter>;
  productIds?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
};

export type RootQueryTypeIcpGeographyWinLossDistributionArgs = {
  globalSettings?: InputMaybe<GlobalSettings>;
  matchFile?: InputMaybe<CompanyMatchFilter>;
};

export type RootQueryTypeIcpIndustryDistributionArgs = {
  globalSettings?: InputMaybe<GlobalSettings>;
  matchFile?: InputMaybe<CompanyMatchFilter>;
  productIds?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
};

export type RootQueryTypeIcpRevenueDistributionArgs = {
  globalSettings?: InputMaybe<GlobalSettings>;
  matchFile?: InputMaybe<CompanyMatchFilter>;
  productIds?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
};

export type RootQueryTypeIcpRevenueWinLossDistributionArgs = {
  globalSettings?: InputMaybe<GlobalSettings>;
  matchFile?: InputMaybe<CompanyMatchFilter>;
};

export type RootQueryTypeIcpWinLossIndustryDistributionArgs = {
  globalSettings?: InputMaybe<GlobalSettings>;
  matchFile?: InputMaybe<CompanyMatchFilter>;
};

export type RootQueryTypeInstallArgs = {
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars["Identifier"]["input"]>>>;
  companyMatchFile?: InputMaybe<CompanyMatchFilter>;
  countryAlpha2s?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  fuzzySearch?: InputMaybe<Scalars["String"]["input"]>;
  hgId: Scalars["Identifier"]["input"];
  includeCorporateDescendants?: InputMaybe<Scalars["Boolean"]["input"]>;
  installAge?: InputMaybe<Scalars["Int"]["input"]>;
  localizeInstalls?: InputMaybe<Scalars["Boolean"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  per?: InputMaybe<Scalars["Int"]["input"]>;
  productAttributeIds?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  productIds?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  regionName?: InputMaybe<Scalars["String"]["input"]>;
  sort?: InputMaybe<Array<InputMaybe<Sort>>>;
  vendorIds?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
};

export type RootQueryTypeInstallProductCountByVendorArgs = {
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars["Identifier"]["input"]>>>;
  companyMatchFile?: InputMaybe<CompanyMatchFilter>;
  countryAlpha2s?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  hgIds?: InputMaybe<Array<InputMaybe<Scalars["Identifier"]["input"]>>>;
  installAge?: InputMaybe<Scalars["Int"]["input"]>;
  localizeInstalls?: InputMaybe<Scalars["Boolean"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  per?: InputMaybe<Scalars["Int"]["input"]>;
  productIds?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  sort?: InputMaybe<Array<InputMaybe<Sort>>>;
  vendorIds?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
};

export type RootQueryTypeInstallVendorCountByCategoryArgs = {
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars["Identifier"]["input"]>>>;
  companyMatchFile?: InputMaybe<CompanyMatchFilter>;
  countryAlpha2s?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  hgId: Scalars["Identifier"]["input"];
  installAge?: InputMaybe<Scalars["Int"]["input"]>;
  isRolledUp?: InputMaybe<Scalars["Boolean"]["input"]>;
  localizeInstalls?: InputMaybe<Scalars["Boolean"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  per?: InputMaybe<Scalars["Int"]["input"]>;
  productIds?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  sort?: InputMaybe<Array<InputMaybe<Sort>>>;
  vendorIds?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
};

export type RootQueryTypeInstallsArgs = {
  attributeIds?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars["Identifier"]["input"]>>>;
  companyFilters?: InputMaybe<CompanyFilter>;
  companyMatchFile?: InputMaybe<CompanyMatchFilter>;
  hgIds?: InputMaybe<Array<InputMaybe<Scalars["Identifier"]["input"]>>>;
  installAge?: InputMaybe<Scalars["Int"]["input"]>;
  localizeInstalls?: InputMaybe<Scalars["Boolean"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  per?: InputMaybe<Scalars["Int"]["input"]>;
  productIds?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  sort?: InputMaybe<Array<InputMaybe<Sort>>>;
  vendorIds?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
};

export type RootQueryTypeIntensityMomentumArgs = {
  hgId: Scalars["Identifier"]["input"];
  page?: InputMaybe<Scalars["Int"]["input"]>;
  per?: InputMaybe<Scalars["Int"]["input"]>;
};

export type RootQueryTypeIntensityOverTimeArgs = {
  hgId: Scalars["Identifier"]["input"];
  productIds?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
};

export type RootQueryTypeIntensityTrendArgs = {
  hgId: Scalars["Identifier"]["input"];
  page?: InputMaybe<Scalars["Int"]["input"]>;
  per?: InputMaybe<Scalars["Int"]["input"]>;
};

export type RootQueryTypeIntentArgs = {
  companyFilters?: InputMaybe<CompanyFilter>;
  companyMatchFile?: InputMaybe<CompanyMatchFilter>;
  hgIds?: InputMaybe<Array<InputMaybe<Scalars["Identifier"]["input"]>>>;
  ignoreProvisioning?: InputMaybe<Scalars["Boolean"]["input"]>;
  includeCorporateDescendants?: InputMaybe<Scalars["Boolean"]["input"]>;
  installAge?: InputMaybe<Scalars["Int"]["input"]>;
  intent?: InputMaybe<IntentFilter>;
  localizeInstalls?: InputMaybe<Scalars["Boolean"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  per?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<Array<InputMaybe<Sort>>>;
  techTopicsOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
  urlIds?: InputMaybe<Array<InputMaybe<Scalars["Identifier"]["input"]>>>;
  urlInstallIds?: InputMaybe<Array<InputMaybe<Scalars["Identifier"]["input"]>>>;
};

export type RootQueryTypeIntentContextArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars["Identifier"]["input"]>>>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  per?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<Array<InputMaybe<Sort>>>;
  topicId?: InputMaybe<Scalars["Identifier"]["input"]>;
  urlId?: InputMaybe<Scalars["Identifier"]["input"]>;
};

export type RootQueryTypeMarketPenetrationArgs = {
  companyFilters: CompanyFilter;
  companyMatchFile?: InputMaybe<CompanyMatchFilter>;
  installAge?: InputMaybe<Scalars["Int"]["input"]>;
  localizeInstalls?: InputMaybe<Scalars["Boolean"]["input"]>;
  productIds: Array<InputMaybe<Scalars["Int"]["input"]>>;
};

export type RootQueryTypeMarketPenetrationOverTimeArgs = {
  companyFilters: CompanyFilter;
  companyMatchFile?: InputMaybe<CompanyMatchFilter>;
  installAge?: InputMaybe<Scalars["Int"]["input"]>;
  localizeInstalls?: InputMaybe<Scalars["Boolean"]["input"]>;
  lookbackYears: Scalars["Int"]["input"];
  productIds: Array<InputMaybe<Scalars["Int"]["input"]>>;
};

export type RootQueryTypeMarketTimeSeriesProductAttributeBreakdownArgs = {
  attributeIds: Array<InputMaybe<Scalars["Int"]["input"]>>;
  companyFilters?: InputMaybe<OpportunityGeneratorFilter>;
  companyMatchFile?: InputMaybe<CompanyMatchFilter>;
  localizeInstalls?: InputMaybe<Scalars["Boolean"]["input"]>;
  lookBackYears?: InputMaybe<Scalars["Int"]["input"]>;
  metric: MarketTimeSeriesMetric;
  period: MarketTimeSeriesPeriod;
};

export type RootQueryTypeMarketTimeSeriesProductBreakdownArgs = {
  companyFilters?: InputMaybe<OpportunityGeneratorFilter>;
  companyMatchFile?: InputMaybe<CompanyMatchFilter>;
  localizeInstalls?: InputMaybe<Scalars["Boolean"]["input"]>;
  lookBackYears?: InputMaybe<Scalars["Int"]["input"]>;
  metric: MarketTimeSeriesMetric;
  period: MarketTimeSeriesPeriod;
  productIds: Array<InputMaybe<Scalars["Int"]["input"]>>;
};

export type RootQueryTypeMarketTimeSeriesProductCategoryBreakdownArgs = {
  categoryIds: Array<InputMaybe<Scalars["Identifier"]["input"]>>;
  companyFilters?: InputMaybe<OpportunityGeneratorFilter>;
  companyMatchFile?: InputMaybe<CompanyMatchFilter>;
  localizeInstalls?: InputMaybe<Scalars["Boolean"]["input"]>;
  lookBackYears?: InputMaybe<Scalars["Int"]["input"]>;
  metric: MarketTimeSeriesMetric;
  period: MarketTimeSeriesPeriod;
};

export type RootQueryTypeMarketTimeSeriesVendorBreakdownArgs = {
  companyFilters?: InputMaybe<OpportunityGeneratorFilter>;
  companyMatchFile?: InputMaybe<CompanyMatchFilter>;
  localizeInstalls?: InputMaybe<Scalars["Boolean"]["input"]>;
  lookBackYears?: InputMaybe<Scalars["Int"]["input"]>;
  metric: MarketTimeSeriesMetric;
  period: MarketTimeSeriesPeriod;
  vendorIds: Array<InputMaybe<Scalars["Int"]["input"]>>;
};

export type RootQueryTypeOpportunityGeneratorSearchArgs = {
  companyMatchFile?: InputMaybe<CompanyMatchFilter>;
  competitorPresence?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  filters?: InputMaybe<OpportunityGeneratorFilter>;
  installAge?: InputMaybe<Scalars["Int"]["input"]>;
  isPlatformPermissible?: InputMaybe<Scalars["Boolean"]["input"]>;
  isV1Dataset?: InputMaybe<Scalars["Boolean"]["input"]>;
  localizeInstalls?: InputMaybe<Scalars["Boolean"]["input"]>;
  localizeInstallsForProfile?: InputMaybe<Scalars["Boolean"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  per?: InputMaybe<Scalars["Int"]["input"]>;
  rgifExclusiveCompany?: InputMaybe<Scalars["Boolean"]["input"]>;
  runQuery?: InputMaybe<Scalars["Boolean"]["input"]>;
  scoring?: InputMaybe<Array<InputMaybe<ScoringProfile>>>;
  scoringProfileId?: InputMaybe<Scalars["Int"]["input"]>;
  scoringProfiles?: InputMaybe<
    Array<InputMaybe<OpportunityGeneratorScoringProfileSalesplaySearch>>
  >;
  sort?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type RootQueryTypePresenceByDepartmentArgs = {
  companyFilters: CompanyFilter;
  companyMatchFile?: InputMaybe<CompanyMatchFilter>;
  installAge?: InputMaybe<Scalars["Int"]["input"]>;
  localizeInstalls?: InputMaybe<Scalars["Boolean"]["input"]>;
  productIds: Array<InputMaybe<Scalars["Int"]["input"]>>;
};

export type RootQueryTypeProductCatalogInstallsCountArgs = {
  attributeIds?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars["Identifier"]["input"]>>>;
  companyMatchFile?: InputMaybe<CompanyMatchFilter>;
  installAge?: InputMaybe<Scalars["Int"]["input"]>;
  localizeInstalls?: InputMaybe<Scalars["Boolean"]["input"]>;
  vendorIds?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
};

export type RootQueryTypeProductCatalogInstallsProductsArgs = {
  attributeIds?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars["Identifier"]["input"]>>>;
  companyMatchFile?: InputMaybe<CompanyMatchFilter>;
  installAge?: InputMaybe<Scalars["Int"]["input"]>;
  localizeInstalls?: InputMaybe<Scalars["Boolean"]["input"]>;
  vendorIds?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
};

export type RootQueryTypeProductDetectionsBySegmentArgs = {
  companyFilters: CompanyFilter;
  companyMatchFile?: InputMaybe<CompanyMatchFilter>;
  installAge?: InputMaybe<Scalars["Int"]["input"]>;
  localizeInstalls?: InputMaybe<Scalars["Boolean"]["input"]>;
  lookbackYears: Scalars["Int"]["input"];
  productIds: Array<InputMaybe<Scalars["Int"]["input"]>>;
  segment: ProductDetectionSegments;
};

export type RootQueryTypeProductTrendArgs = {
  companyMatchFile?: InputMaybe<CompanyMatchFilter>;
  hgId: Scalars["Identifier"]["input"];
  installAge?: InputMaybe<Scalars["Int"]["input"]>;
  intensityTrendMomentum?: InputMaybe<Scalars["Boolean"]["input"]>;
  localizeInstalls?: InputMaybe<Scalars["Boolean"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  per?: InputMaybe<Scalars["Int"]["input"]>;
  productIds?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  sort?: InputMaybe<Array<InputMaybe<Sort>>>;
  startDate?: InputMaybe<Scalars["String"]["input"]>;
};

export type RootQueryTypeRecentInstallsArgs = {
  companyFilters: CompanyFilter;
  companyMatchFile?: InputMaybe<CompanyMatchFilter>;
  installAge?: InputMaybe<Scalars["Int"]["input"]>;
  localizeInstalls?: InputMaybe<Scalars["Boolean"]["input"]>;
  productIds: Array<InputMaybe<Scalars["Int"]["input"]>>;
};

export type RootQueryTypeRowCountCheckArgs = {
  companyFilters?: InputMaybe<OpportunityGeneratorFilter>;
  companyMatchFile?: InputMaybe<CompanyMatchFilter>;
  companyScores?: InputMaybe<Array<InputMaybe<ScoringProfile>>>;
  companyScoringProfileId?: InputMaybe<Scalars["Int"]["input"]>;
  companyScoringProfiles?: InputMaybe<
    Array<InputMaybe<OpportunityGeneratorScoringProfileSalesplaySearch>>
  >;
  companySort?: InputMaybe<Array<InputMaybe<Sort>>>;
  contractsInclusion?: InputMaybe<InclusionType>;
  faiInclusion?: InputMaybe<InclusionType>;
  faiProductIds?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  includeDecisionMakersAndInfluencersOnly?: InputMaybe<
    Scalars["Boolean"]["input"]
  >;
  installAge?: InputMaybe<Scalars["Int"]["input"]>;
  installInclusion?: InputMaybe<InclusionType>;
  installProductIds?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
  intentInclusion?: InputMaybe<InclusionType>;
  intentSignalScore?: InputMaybe<SignalScore>;
  localizeInstalls?: InputMaybe<Scalars["Boolean"]["input"]>;
  topicIds?: InputMaybe<Array<InputMaybe<Scalars["Identifier"]["input"]>>>;
};

export type RootQueryTypeScoringProfileHumanReadableVersionArgs = {
  scoringProfileCriteria?: InputMaybe<Scalars["String"]["input"]>;
  scoringProfileId?: InputMaybe<Scalars["Int"]["input"]>;
};

export type RootQueryTypeSearchArgs = {
  companyMatchFile?: InputMaybe<CompanyMatchFilter>;
  filters?: InputMaybe<CompanyFilter>;
  installAge?: InputMaybe<Scalars["Int"]["input"]>;
  localizeInstalls?: InputMaybe<Scalars["Boolean"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  per?: InputMaybe<Scalars["Int"]["input"]>;
  runQuery?: InputMaybe<Scalars["Boolean"]["input"]>;
  scoring?: InputMaybe<Array<InputMaybe<ScoringProfile>>>;
  sort?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type RootQueryTypeSearchCompaniesArgs = {
  companyMatchFile?: InputMaybe<CompanyMatchFilter>;
  filters?: InputMaybe<CompanyFilter>;
  installAge?: InputMaybe<Scalars["Int"]["input"]>;
  localizeInstalls?: InputMaybe<Scalars["Boolean"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  per?: InputMaybe<Scalars["Int"]["input"]>;
  scoring?: InputMaybe<Array<InputMaybe<ScoringProfile>>>;
  sort?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type RootQueryTypeSearchCompaniesV2Args = {
  filters?: InputMaybe<SearchCompaniesV2Filters>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  per?: InputMaybe<Scalars["Int"]["input"]>;
  query: Scalars["String"]["input"];
  sort?: InputMaybe<Array<InputMaybe<SearchCompaniesV2Sort>>>;
};

export type RootQueryTypeSearchCompanyNamesArgs = {
  companyMatchFile?: InputMaybe<CompanyMatchFilter>;
  filters?: InputMaybe<CompanyFilter>;
  installAge?: InputMaybe<Scalars["Int"]["input"]>;
  localizeInstalls?: InputMaybe<Scalars["Boolean"]["input"]>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  per?: InputMaybe<Scalars["Int"]["input"]>;
  scoring?: InputMaybe<Array<InputMaybe<ScoringProfile>>>;
  sort?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type RootQueryTypeSegmentAnalysisCountryBreakdownArgs = {
  companyFilters?: InputMaybe<OpportunityGeneratorFilter>;
  companyMatchFile?: InputMaybe<CompanyMatchFilter>;
  customSpendCategory?: InputMaybe<CustomSpendCategory>;
  installAge?: InputMaybe<Scalars["Int"]["input"]>;
  localizeInstalls?: InputMaybe<Scalars["Boolean"]["input"]>;
  spendCategoryIds?: InputMaybe<
    Array<InputMaybe<Scalars["Identifier"]["input"]>>
  >;
};

export type RootQueryTypeSegmentAnalysisEmployeeRangeBreakdownArgs = {
  companyFilters?: InputMaybe<OpportunityGeneratorFilter>;
  companyMatchFile?: InputMaybe<CompanyMatchFilter>;
  customSpendCategory?: InputMaybe<CustomSpendCategory>;
  installAge?: InputMaybe<Scalars["Int"]["input"]>;
  localizeInstalls?: InputMaybe<Scalars["Boolean"]["input"]>;
  ranges?: InputMaybe<Array<InputMaybe<InputIntegerRange>>>;
  spendCategoryIds?: InputMaybe<
    Array<InputMaybe<Scalars["Identifier"]["input"]>>
  >;
};

export type RootQueryTypeSegmentAnalysisIndustryBreakdownArgs = {
  companyFilters?: InputMaybe<OpportunityGeneratorFilter>;
  companyMatchFile?: InputMaybe<CompanyMatchFilter>;
  customSpendCategory?: InputMaybe<CustomSpendCategory>;
  installAge?: InputMaybe<Scalars["Int"]["input"]>;
  localizeInstalls?: InputMaybe<Scalars["Boolean"]["input"]>;
  spendCategoryIds?: InputMaybe<
    Array<InputMaybe<Scalars["Identifier"]["input"]>>
  >;
};

export type RootQueryTypeSegmentAnalysisNaicsBreakdownArgs = {
  companyFilters?: InputMaybe<OpportunityGeneratorFilter>;
  companyMatchFile?: InputMaybe<CompanyMatchFilter>;
  customSpendCategory?: InputMaybe<CustomSpendCategory>;
  installAge?: InputMaybe<Scalars["Int"]["input"]>;
  localizeInstalls?: InputMaybe<Scalars["Boolean"]["input"]>;
  spendCategoryIds?: InputMaybe<
    Array<InputMaybe<Scalars["Identifier"]["input"]>>
  >;
};

export type RootQueryTypeSegmentAnalysisRevenueRangeBreakdownArgs = {
  companyFilters?: InputMaybe<OpportunityGeneratorFilter>;
  companyMatchFile?: InputMaybe<CompanyMatchFilter>;
  customSpendCategory?: InputMaybe<CustomSpendCategory>;
  installAge?: InputMaybe<Scalars["Int"]["input"]>;
  localizeInstalls?: InputMaybe<Scalars["Boolean"]["input"]>;
  spendCategoryIds?: InputMaybe<
    Array<InputMaybe<Scalars["Identifier"]["input"]>>
  >;
};

export type RootQueryTypeSpendArgs = {
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars["Identifier"]["input"]>>>;
  categoryParentIds?: InputMaybe<
    Array<InputMaybe<Scalars["Identifier"]["input"]>>
  >;
  hgIds?: InputMaybe<Array<InputMaybe<Scalars["Identifier"]["input"]>>>;
  hgIdsIncludingCorporateRelatives?: InputMaybe<
    Array<InputMaybe<Scalars["Identifier"]["input"]>>
  >;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  per?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type RootQueryTypeSpendDynamicsArgs = {
  companyFilters?: InputMaybe<OpportunityGeneratorFilter>;
  companyMatchFile?: InputMaybe<CompanyMatchFilter>;
  customSpendCategories?: InputMaybe<Array<InputMaybe<CustomSpendCategory>>>;
  installAge?: InputMaybe<Scalars["Int"]["input"]>;
  localizeInstalls?: InputMaybe<Scalars["Boolean"]["input"]>;
  opportunityGeneratorFilters?: InputMaybe<OpportunityGeneratorFilter>;
  ranges?: InputMaybe<Array<InputMaybe<InputIntegerRange>>>;
  spendCategoryIds?: InputMaybe<
    Array<InputMaybe<Scalars["Identifier"]["input"]>>
  >;
  view: SpendDynamicsView;
};

export type RootQueryTypeTechnologyMarketShareArgs = {
  companyFilters: CompanyFilter;
  companyMatchFile?: InputMaybe<CompanyMatchFilter>;
  compareAcross: TechnologyMarketShareCompareAcross;
  groupBy: TechnologyMarketShareGroupBy;
  installAge?: InputMaybe<Scalars["Int"]["input"]>;
  localizeInstalls?: InputMaybe<Scalars["Boolean"]["input"]>;
  opportunityGeneratorFilters?: InputMaybe<OpportunityGeneratorFilter>;
  orderBy: TechnologyMarketShareOrderBy;
  productIds: Array<InputMaybe<Scalars["Int"]["input"]>>;
  ranges?: InputMaybe<Array<InputMaybe<InputIntegerRange>>>;
};

export type RootQueryTypeTopProductsArgs = {
  companyFilters?: InputMaybe<OpportunityGeneratorFilter>;
  companyMatchFile?: InputMaybe<CompanyMatchFilter>;
  installAge?: InputMaybe<Scalars["Int"]["input"]>;
  localizeInstalls?: InputMaybe<Scalars["Boolean"]["input"]>;
  productCategoryIds: Array<InputMaybe<Scalars["Identifier"]["input"]>>;
};

export type RootQueryTypeTopProductsForVendorArgs = {
  companyFilters?: InputMaybe<OpportunityGeneratorFilter>;
  companyMatchFile?: InputMaybe<CompanyMatchFilter>;
  installAge?: InputMaybe<Scalars["Int"]["input"]>;
  localizeInstalls?: InputMaybe<Scalars["Boolean"]["input"]>;
  productCategoryIds: Array<InputMaybe<Scalars["Identifier"]["input"]>>;
  vendorId: Scalars["Int"]["input"];
};

export type RootQueryTypeTopVendorsArgs = {
  companyFilters?: InputMaybe<OpportunityGeneratorFilter>;
  companyMatchFile?: InputMaybe<CompanyMatchFilter>;
  installAge?: InputMaybe<Scalars["Int"]["input"]>;
  localizeInstalls?: InputMaybe<Scalars["Boolean"]["input"]>;
  productCategoryIds: Array<InputMaybe<Scalars["Identifier"]["input"]>>;
};

export type RootQueryTypeTopVendorsByProductCountArgs = {
  companyMatchFile?: InputMaybe<CompanyMatchFilter>;
  filters: CompanyProfileInstallFilters;
  hgId: Scalars["Identifier"]["input"];
  installAge?: InputMaybe<Scalars["Int"]["input"]>;
  localizeInstalls?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type RootQueryTypeTotalMarketSummaryArgs = {
  companyFilters?: InputMaybe<OpportunityGeneratorFilter>;
  companyMatchFile?: InputMaybe<CompanyMatchFilter>;
  customSpendCategory?: InputMaybe<CustomSpendCategory>;
  installAge?: InputMaybe<Scalars["Int"]["input"]>;
  localizeInstalls?: InputMaybe<Scalars["Boolean"]["input"]>;
  spendCategoryIds?: InputMaybe<
    Array<InputMaybe<Scalars["Identifier"]["input"]>>
  >;
};

export type RootQueryTypeVendorPresenceArgs = {
  companyMatchFile?: InputMaybe<CompanyMatchFilter>;
  hgIds?: InputMaybe<Array<InputMaybe<Scalars["Identifier"]["input"]>>>;
  installAge?: InputMaybe<Scalars["Int"]["input"]>;
  localizeInstalls?: InputMaybe<Scalars["Boolean"]["input"]>;
  vendorIds?: InputMaybe<Array<InputMaybe<Scalars["Int"]["input"]>>>;
};

export type ScoringProfile = {
  buyersJourney?: InputMaybe<Array<InputMaybe<BuyersJourneyScore>>>;
  cloudMaturity?: InputMaybe<Array<InputMaybe<CloudMaturityScore>>>;
  contextType?: InputMaybe<Array<InputMaybe<ContextTypeScore>>>;
  employees?: InputMaybe<Array<InputMaybe<MinMaxScore>>>;
  geography?: InputMaybe<Array<InputMaybe<LocationScore>>>;
  globalPresence?: InputMaybe<Array<InputMaybe<GlobalPresenceScore>>>;
  industry?: InputMaybe<Array<InputMaybe<IndustryScore>>>;
  location?: InputMaybe<Array<InputMaybe<SignalLocationScore>>>;
  name: Scalars["String"]["input"];
  productCategoryPenetration?: InputMaybe<
    Array<InputMaybe<CategoryMinMaxScore>>
  >;
  productInstallAge?: InputMaybe<
    Array<InputMaybe<ProductInstallAgeMinMaxScore>>
  >;
  productIntensity?: InputMaybe<Array<InputMaybe<ProductIntensityScore>>>;
  products?: InputMaybe<Array<InputMaybe<ProductPresenceScore>>>;
  revenue?: InputMaybe<Array<InputMaybe<MinMaxScore>>>;
  signalStrength?: InputMaybe<Array<InputMaybe<SignalStrengthScore>>>;
  spend?: InputMaybe<Array<InputMaybe<SpendMinMaxScore>>>;
  sum?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  vendorPenetration?: InputMaybe<Array<InputMaybe<VendorMinMaxScore>>>;
  wasGenerated?: InputMaybe<Scalars["Boolean"]["input"]>;
  weight?: InputMaybe<Scalars["Int"]["input"]>;
};

export type ScoringProfileHumanReadable = {
  __typename?: "ScoringProfileHumanReadable";
  data: Maybe<ScoringProfileHumanReadableItems>;
};

export type ScoringProfileHumanReadableItem = {
  __typename?: "ScoringProfileHumanReadableItem";
  labels: Maybe<Array<Maybe<ScoringProfileHumanReadableItemLabel>>>;
  name: Maybe<Scalars["String"]["output"]>;
  topLabel: Maybe<Scalars["String"]["output"]>;
  type: Maybe<Scalars["String"]["output"]>;
  weight: Maybe<Scalars["Int"]["output"]>;
};

export type ScoringProfileHumanReadableItemLabel = {
  __typename?: "ScoringProfileHumanReadableItemLabel";
  inclusionMethod: Maybe<Scalars["String"]["output"]>;
  name: Maybe<Scalars["String"]["output"]>;
  score: Maybe<Scalars["Int"]["output"]>;
};

export type ScoringProfileHumanReadableItems = {
  __typename?: "ScoringProfileHumanReadableItems";
  fitScoring: Maybe<Array<Maybe<ScoringProfileHumanReadableItem>>>;
  intentScoring: Maybe<Array<Maybe<ScoringProfileHumanReadableItem>>>;
};

export type ScoringTableReady = {
  __typename?: "ScoringTableReady";
  count: Maybe<Scalars["Int"]["output"]>;
  data: Maybe<Scalars["Boolean"]["output"]>;
};

export type ScoringTablesStatus = {
  __typename?: "ScoringTablesStatus";
  notReady: Maybe<Array<Maybe<Scalars["Int"]["output"]>>>;
  ready: Maybe<Array<Maybe<Scalars["Int"]["output"]>>>;
};

export type ScoringTablesStatusData = {
  __typename?: "ScoringTablesStatusData";
  count: Maybe<Scalars["Int"]["output"]>;
  data: Maybe<ScoringTablesStatus>;
};

export type SearchCompaniesV2Filters = {
  companyType?: InputMaybe<CompanyTypes>;
  countryAlpha2s?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  excludedCountryAlpha2s?: InputMaybe<
    Array<InputMaybe<Scalars["String"]["input"]>>
  >;
  isDu?: InputMaybe<Scalars["Boolean"]["input"]>;
  isGu?: InputMaybe<Scalars["Boolean"]["input"]>;
  regionNames?: InputMaybe<Array<InputMaybe<RegionNames>>>;
  stateIds?: InputMaybe<Array<InputMaybe<Scalars["Identifier"]["input"]>>>;
};

export type SearchCompaniesV2Sort = {
  direction?: InputMaybe<SortDir>;
  field?: InputMaybe<SearchCompaniesV2SortKeys>;
};

export enum SearchCompaniesV2SortKeys {
  DUNS = "DUNS",
  EMPLOYEE_RANGE_MIN = "EMPLOYEE_RANGE_MIN",
  IT_SPEND = "IT_SPEND",
  LOCATION_PRIMARY_STATE_COUNTRY_NAME = "LOCATION_PRIMARY_STATE_COUNTRY_NAME",
  NAME = "NAME",
  REVENUE_RANGE_MIN = "REVENUE_RANGE_MIN",
  TERM_INDEX = "TERM_INDEX",
  URL = "URL",
}

export type ServiceLine = {
  __typename?: "ServiceLine";
  contractUuid: Maybe<Scalars["String"]["output"]>;
  delivery: Maybe<Scalars["String"]["output"]>;
  geographicScope: Maybe<Scalars["String"]["output"]>;
  id: Maybe<Scalars["Identifier"]["output"]>;
  percent: Maybe<Scalars["Int"]["output"]>;
  role: Maybe<Scalars["String"]["output"]>;
  serviceTypes: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  vendorDuns: Maybe<Scalars["Int"]["output"]>;
  vendorId: Maybe<Scalars["String"]["output"]>;
  vendorName: Maybe<Scalars["String"]["output"]>;
};

export type SicUs1987 = {
  __typename?: "SicUs1987";
  code: Maybe<Scalars["String"]["output"]>;
  codeStandard: Maybe<Scalars["String"]["output"]>;
  id: Maybe<Scalars["Int"]["output"]>;
  name: Maybe<Scalars["String"]["output"]>;
  parentId: Maybe<Scalars["String"]["output"]>;
  topLevelParent: Maybe<TopParentSicUs1987>;
};

export type SicUs1987Agg = {
  __typename?: "SicUs1987Agg";
  code: Maybe<Scalars["String"]["output"]>;
  name: Maybe<Scalars["String"]["output"]>;
  topLevelParent: Maybe<TopParentSicUs1987Agg>;
};

export type SignalLocationScore = {
  location: LocationFilter;
  score?: Scalars["Int"]["input"];
  topics: IdentInclusionFilter;
};

export enum SignalScore {
  HIGH = "HIGH",
  MEDIUM = "MEDIUM",
}

export type SignalStrengthScore = {
  score?: Scalars["Int"]["input"];
  signalScore: MinMaxFilter;
  topics: IdentInclusionFilter;
};

export type Sort = {
  direction?: InputMaybe<SortDir>;
  field?: InputMaybe<Scalars["String"]["input"]>;
};

export enum SortDir {
  ASC = "ASC",
  DESC = "DESC",
}

/** A scoring model's readable score columns. `composite`/`tier` are always produced; `fit`/`need`/`intent` only when the model scores them. */
export enum ModelScoreColumn {
  COMPOSITE = "COMPOSITE",
  FIT = "FIT",
  INTENT = "INTENT",
  NEED = "NEED",
  TIER = "TIER",
}

/** Columns a model score can be sorted by. `tier` is excluded — its lexical order would mislead. */
export enum ModelScoreSortColumn {
  COMPOSITE = "COMPOSITE",
  FIT = "FIT",
  INTENT = "INTENT",
  NEED = "NEED",
}

/** Request per-model scores for the listing. `modelId` is the scoring model's stable family id (from the Argo catalog). */
export type ModelScoreInput = {
  columns?: InputMaybe<Array<InputMaybe<ModelScoreColumn>>>;
  modelId: Scalars["String"]["input"];
};

/** Sort the listing by one model's score column. `modelId` must be one of the request's `model_scores`. */
export type ModelScoreSortInput = {
  column: ModelScoreSortColumn;
  direction?: InputMaybe<SortDir>;
  modelId: Scalars["String"]["input"];
};

/** Columns a model score can be filtered by. `composite`/`fit`/`need`/`intent` use numeric min/max; `tier` uses eq/in. */
export enum ModelScoreFilterColumn {
  COMPOSITE = "COMPOSITE",
  FIT = "FIT",
  INTENT = "INTENT",
  NEED = "NEED",
  TIER = "TIER",
}

/**
 * Hard filter on one model's score. `modelId` must be one of the request's `model_scores`.
 * `COMPOSITE`/`FIT`/`NEED`/`INTENT` use inclusive `min`/`max`; `TIER` uses `eq` (one letter) or `in` (a set),
 * uppercase-canonical.
 */
export type ModelScoreFilterInput = {
  column: ModelScoreFilterColumn;
  eq?: InputMaybe<Scalars["String"]["input"]>;
  in?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  max?: InputMaybe<Scalars["Int"]["input"]>;
  min?: InputMaybe<Scalars["Int"]["input"]>;
  modelId: Scalars["String"]["input"];
};

export type Spend = {
  __typename?: "Spend";
  absoluteValue: Maybe<Scalars["Int"]["output"]>;
  category: Maybe<SpendCategory>;
  country: Maybe<Country>;
  countryAlpha2: Maybe<Scalars["String"]["output"]>;
  hgId: Maybe<Scalars["Identifier"]["output"]>;
  relativeValue: Maybe<Scalars["Int"]["output"]>;
  sumRelativeValues: Maybe<Scalars["LongInt"]["output"]>;
};

export type SpendCategory = {
  __typename?: "SpendCategory";
  description: Maybe<Scalars["String"]["output"]>;
  id: Maybe<Scalars["Identifier"]["output"]>;
  name: Maybe<Scalars["String"]["output"]>;
  nameTree: Maybe<Array<Maybe<Scalars["String"]["output"]>>>;
  parentId: Maybe<Scalars["Identifier"]["output"]>;
};

export type SpendCategorySpendBreakdown = {
  __typename?: "SpendCategorySpendBreakdown";
  companyCount: Maybe<Scalars["Int"]["output"]>;
  spendCategoryId: Maybe<Scalars["Identifier"]["output"]>;
  spendCategoryName: Maybe<Scalars["String"]["output"]>;
  totalSpend: Maybe<Scalars["Int"]["output"]>;
};

export type SpendData = {
  __typename?: "SpendData";
  count: Maybe<Scalars["Int"]["output"]>;
  data: Maybe<Array<Maybe<Spend>>>;
};

export type SpendDynamicsBreakdown = {
  __typename?: "SpendDynamicsBreakdown";
  companyCount: Maybe<Scalars["Int"]["output"]>;
  dimensionX: Maybe<SpendDynamicsDimensionX>;
  dimensionY: Maybe<SpendDynamicsDimensionY>;
  totalSpend: Maybe<Scalars["Int"]["output"]>;
};

export type SpendDynamicsDimensionX = Country | IntegerRange;

export type SpendDynamicsDimensionY = Country | Naics2012;

export enum SpendDynamicsView {
  COUNTRY_BY_EMPLOYEES = "COUNTRY_BY_EMPLOYEES",
  COUNTRY_BY_REVENUE = "COUNTRY_BY_REVENUE",
  INDUSTRY_BY_COUNTRY = "INDUSTRY_BY_COUNTRY",
  INDUSTRY_BY_EMPLOYEES = "INDUSTRY_BY_EMPLOYEES",
  INDUSTRY_BY_REVENUE = "INDUSTRY_BY_REVENUE",
}

export type SpendFilter = {
  categoryId: Scalars["Identifier"]["input"];
  max?: InputMaybe<Scalars["Int"]["input"]>;
  min?: InputMaybe<Scalars["Int"]["input"]>;
};

export type SpendMinMaxScore = {
  categoryId: Scalars["Identifier"]["input"];
  max?: InputMaybe<Scalars["Int"]["input"]>;
  min?: InputMaybe<Scalars["Int"]["input"]>;
  score?: Scalars["Int"]["input"];
};

export type SqlObjectResponse = {
  __typename?: "SqlObjectResponse";
  count: Maybe<Scalars["Int"]["output"]>;
  data: Maybe<Scalars["String"]["output"]>;
};

export type State = {
  __typename?: "State";
  country: Maybe<Country>;
  id: Maybe<Scalars["Identifier"]["output"]>;
  name: Maybe<Scalars["String"]["output"]>;
};

export type StockExchange = {
  __typename?: "StockExchange";
  name: Maybe<Scalars["String"]["output"]>;
  ticker: Maybe<Scalars["String"]["output"]>;
};

export type SubsidiaryLocationInput = {
  /** Count of matching subsidiaries */
  countMatching?: InputMaybe<Scalars["Int"]["input"]>;
  /** List of subsidiary country codes */
  countryCodes?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  /** Inclusion method for subsidiary locations */
  inclusionMethod?: InputMaybe<Scalars["String"]["input"]>;
  /** List of subsidiary regions */
  regions?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type SubsidiaryPresenceFilter = {
  countMatching?: InputMaybe<Scalars["Int"]["input"]>;
  countryCodes?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
  inclusionMethod?: InputMaybe<InclusionMethod>;
  regions?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type TableFilter = {
  columnName: Scalars["String"]["input"];
  tableName: Scalars["String"]["input"];
};

export type TechnologyMarketShareBreakdown = {
  __typename?: "TechnologyMarketShareBreakdown";
  dimensionX: Maybe<TechnologyMarketShareDimensionX>;
  installs: Maybe<Array<Maybe<TechnologyMarketShareInstallData>>>;
};

export enum TechnologyMarketShareCompareAcross {
  COUNTRY = "COUNTRY",
  EMPLOYEES = "EMPLOYEES",
  HG_INDUSTRY = "HG_INDUSTRY",
  INDUSTRY = "INDUSTRY",
  REGION = "REGION",
  REVENUE = "REVENUE",
}

export type TechnologyMarketShareDimensionX =
  | Country
  | Industry
  | IntegerRange
  | Naics2012
  | Region;

export enum TechnologyMarketShareGroupBy {
  PRODUCT = "PRODUCT",
  VENDOR = "VENDOR",
}

export type TechnologyMarketShareInstallData = {
  __typename?: "TechnologyMarketShareInstallData";
  companyCount: Maybe<Scalars["Int"]["output"]>;
  id: Maybe<Scalars["Int"]["output"]>;
  penetrationPercent: Maybe<Scalars["Int"]["output"]>;
};

export enum TechnologyMarketShareOrderBy {
  COUNT = "COUNT",
  PERCENT = "PERCENT",
}

export type TopParentNaics2012 = {
  __typename?: "TopParentNaics2012";
  code: Maybe<Scalars["String"]["output"]>;
  id: Maybe<Scalars["Identifier"]["output"]>;
  name: Maybe<Scalars["String"]["output"]>;
};

export type TopParentNaics2012Agg = {
  __typename?: "TopParentNaics2012Agg";
  code: Maybe<Scalars["String"]["output"]>;
  name: Maybe<Scalars["String"]["output"]>;
};

export type TopParentSicUs1987 = {
  __typename?: "TopParentSicUs1987";
  code: Maybe<Scalars["String"]["output"]>;
  id: Maybe<Scalars["Int"]["output"]>;
  name: Maybe<Scalars["String"]["output"]>;
};

export type TopParentSicUs1987Agg = {
  __typename?: "TopParentSicUs1987Agg";
  code: Maybe<Scalars["String"]["output"]>;
  name: Maybe<Scalars["String"]["output"]>;
};

export type TopProductsForVendorHit = {
  __typename?: "TopProductsForVendorHit";
  companyCount: Maybe<Scalars["Int"]["output"]>;
  productName: Maybe<Scalars["String"]["output"]>;
};

export type TopProductsHit = {
  __typename?: "TopProductsHit";
  categoryName: Maybe<Scalars["String"]["output"]>;
  companyCount: Maybe<Scalars["Int"]["output"]>;
  productDescription: Maybe<Scalars["String"]["output"]>;
  productId: Maybe<Scalars["Int"]["output"]>;
  productName: Maybe<Scalars["String"]["output"]>;
  vendorName: Maybe<Scalars["String"]["output"]>;
  vendorUrl: Maybe<Scalars["String"]["output"]>;
};

export type TopVendorsHit = {
  __typename?: "TopVendorsHit";
  companyCount: Maybe<Scalars["Int"]["output"]>;
  vendorId: Maybe<Scalars["Int"]["output"]>;
  vendorLocationId: Maybe<Scalars["Identifier"]["output"]>;
  vendorName: Maybe<Scalars["String"]["output"]>;
  vendorUrl: Maybe<Scalars["String"]["output"]>;
};

export type TrafficDistribution = {
  __typename?: "TrafficDistribution";
  byCountry: Maybe<TrafficDistributionCountryPaginated>;
  byRegion: Maybe<Array<Maybe<TrafficDistributionRegion>>>;
};

export type TrafficDistributionByCountryArgs = {
  filters?: InputMaybe<TrafficDistributionCountryFilter>;
  page?: InputMaybe<Scalars["Int"]["input"]>;
  per?: InputMaybe<Scalars["Int"]["input"]>;
  sort?: InputMaybe<Array<InputMaybe<Sort>>>;
};

export type TrafficDistributionCountry = {
  __typename?: "TrafficDistributionCountry";
  averagePing: Maybe<Scalars["Decimal"]["output"]>;
  country: Maybe<Country>;
  dataCenterPresent: Maybe<Scalars["Boolean"]["output"]>;
  region: Maybe<Region>;
  trafficValue: Maybe<Scalars["Decimal"]["output"]>;
};

export type TrafficDistributionCountryFilter = {
  dataCenterOpportunities?: InputMaybe<Scalars["Boolean"]["input"]>;
  regions?: InputMaybe<Array<InputMaybe<Scalars["String"]["input"]>>>;
};

export type TrafficDistributionCountryPaginated = {
  __typename?: "TrafficDistributionCountryPaginated";
  count: Maybe<Scalars["Int"]["output"]>;
  data: Maybe<Array<Maybe<TrafficDistributionCountry>>>;
};

export type TrafficDistributionRegion = {
  __typename?: "TrafficDistributionRegion";
  region: Maybe<Region>;
  trafficValue: Maybe<Scalars["Decimal"]["output"]>;
};

export type Vendor = {
  __typename?: "Vendor";
  fctCompanyLocation: Maybe<Scalars["Identifier"]["output"]>;
  id: Maybe<Scalars["Int"]["output"]>;
  name: Maybe<Scalars["String"]["output"]>;
  url: Maybe<Scalars["String"]["output"]>;
};

export type VendorFilter = {
  /** FAI Departments */
  departmentIds?: InputMaybe<Array<InputMaybe<Scalars["Identifier"]["input"]>>>;
  ids: Array<InputMaybe<Scalars["Int"]["input"]>>;
  inclusionMethod?: InputMaybe<InclusionMethod>;
  installAge?: InputMaybe<MinMaxFilter>;
  installAgeMonths?: InputMaybe<MinMaxFilter>;
  /** 'Number of product installs' filter */
  productCount?: InputMaybe<MinMaxFilter>;
  /** FAI Role */
  roleIds?: InputMaybe<Array<InputMaybe<Scalars["Identifier"]["input"]>>>;
};

export type VendorMinMaxScore = {
  max?: InputMaybe<Scalars["Int"]["input"]>;
  min?: InputMaybe<Scalars["Int"]["input"]>;
  score?: Scalars["Int"]["input"];
  vendorId: Scalars["Int"]["input"];
};

export type VendorPresenceData = {
  __typename?: "VendorPresenceData";
  count: Maybe<Scalars["Int"]["output"]>;
  data: Maybe<Array<Maybe<VendorPresenceResult>>>;
};

export type VendorPresenceResult = {
  __typename?: "VendorPresenceResult";
  hgId: Maybe<Scalars["Identifier"]["output"]>;
  productCount: Maybe<Scalars["Int"]["output"]>;
  vendor: Maybe<Vendor>;
};

export type VendorProductCount = {
  __typename?: "VendorProductCount";
  productCount: Maybe<Scalars["Int"]["output"]>;
  vendorId: Maybe<Scalars["Int"]["output"]>;
  vendorName: Maybe<Scalars["String"]["output"]>;
};

export type WhitespaceFilter = {
  type?: InputMaybe<WhitespaceType>;
};

export enum WhitespaceType {
  MATCH_FILE = "MATCH_FILE",
  NONE = "NONE",
}

export type GetCompanyListBasicQueryVariables = Exact<{
  filters?: InputMaybe<OpportunityGeneratorFilter>;
  localizeInstalls?: InputMaybe<Scalars["Boolean"]["input"]>;
  page: Scalars["Int"]["input"];
  per: Scalars["Int"]["input"];
  sort: Array<InputMaybe<Sort>> | InputMaybe<Sort>;
  scoringProfiles?: InputMaybe<
    | Array<InputMaybe<OpportunityGeneratorScoringProfileSalesplaySearch>>
    | InputMaybe<OpportunityGeneratorScoringProfileSalesplaySearch>
  >;
  tenantId?: InputMaybe<Scalars["String"]["input"]>;
  modelScores?: InputMaybe<
    Array<InputMaybe<ModelScoreInput>> | InputMaybe<ModelScoreInput>
  >;
  modelScoreSort?: InputMaybe<ModelScoreSortInput>;
  modelScoreFilter?: InputMaybe<
    Array<InputMaybe<ModelScoreFilterInput>> | InputMaybe<ModelScoreFilterInput>
  >;
}>;

export type GetCompanyListBasicQuery = {
  __typename?: "RootQueryType";
  opportunity_generator_search: {
    __typename?: "OpportunityGeneratorSearchData";
    count: number | null;
    data: Array<{
      __typename?: "OpportunityGeneratorSearch";
      hgId: string | null;
      name: string | null;
      url: string | null;
      countryName: string | null;
      itSpend: number | null;
      isGhq: boolean | null;
      isDp: boolean | null;
      isGp: boolean | null;
      employeeRange: {
        __typename?: "FirmoRange";
        min: number | null;
        max: number | null;
      } | null;
      revenueRange: {
        __typename?: "FirmoRange";
        min: number | null;
        max: number | null;
      } | null;
      scores: unknown | null;
      model_scores: unknown | null;
    } | null> | null;
  } | null;
};

export type GetCompanyListWithFiltersQueryVariables = Exact<{
  filters?: InputMaybe<OpportunityGeneratorFilter>;
  localizeInstalls?: InputMaybe<Scalars["Boolean"]["input"]>;
  page: Scalars["Int"]["input"];
  per: Scalars["Int"]["input"];
  sort: Array<InputMaybe<Sort>> | InputMaybe<Sort>;
  competitorPresence?: InputMaybe<
    Array<Scalars["Int"]["input"]> | Scalars["Int"]["input"]
  >;
  companyMatchFile?: InputMaybe<CompanyMatchFilter>;
}>;

export type GetCompanyListWithFiltersQuery = {
  __typename?: "RootQueryType";
  opportunity_generator_search: {
    __typename?: "OpportunityGeneratorSearchData";
    count: number | null;
    data: Array<{
      __typename?: "OpportunityGeneratorSearch";
      hgId: string | null;
      name: string | null;
      url: string | null;
      countryName: string | null;
      itSpend: number | null;
      isGhq: boolean | null;
      isDp: boolean | null;
      isGp: boolean | null;
      competitorPresence: Array<number | null> | null;
      isWhitespace: number | null;
      isProspectWhitespace: number | null;
      isExpansionWhitespace: number | null;
      employeeRange: {
        __typename?: "FirmoRange";
        min: number | null;
        max: number | null;
      } | null;
      revenueRange: {
        __typename?: "FirmoRange";
        min: number | null;
        max: number | null;
      } | null;
    } | null> | null;
  } | null;
};

export type GetCompanyIntentQueryVariables = Exact<{
  hgIds:
    | Array<InputMaybe<Scalars["Identifier"]["input"]>>
    | InputMaybe<Scalars["Identifier"]["input"]>;
  includeCorporateDescendants?: InputMaybe<Scalars["Boolean"]["input"]>;
  urlInstallIds?: InputMaybe<
    | Array<InputMaybe<Scalars["Identifier"]["input"]>>
    | InputMaybe<Scalars["Identifier"]["input"]>
  >;
  page: Scalars["Int"]["input"];
  per: Scalars["Int"]["input"];
  sort: Array<InputMaybe<Sort>> | InputMaybe<Sort>;
  intent?: InputMaybe<IntentFilter>;
  ignoreProvisioning?: InputMaybe<Scalars["Boolean"]["input"]>;
  techTopicsOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type GetCompanyIntentQuery = {
  __typename?: "RootQueryType";
  intent: {
    __typename?: "IntentData";
    count: number | null;
    data: Array<{
      __typename?: "Intent";
      url: string | null;
      urlId: string | null;
      score: number | null;
      trend: number | null;
      lastSeenAt: string | null;
      locationScore: number | null;
      topic: {
        __typename?: "IntentTopic";
        id: string | null;
        displayName: string | null;
      } | null;
      buyersJourney: {
        __typename?: "IntentBuyersJourney";
        id: string | null;
        name: string | null;
      } | null;
      contextAggregate: {
        __typename?: "ContextAggregate";
        contextIds: Array<string | null> | null;
        typeNames: Array<string | null> | null;
      } | null;
      location: {
        __typename?: "GeoRange";
        cities: Array<string | null> | null;
        state: {
          __typename?: "State";
          id: string | null;
          name: string | null;
          country: {
            __typename?: "Country";
            alpha2: string | null;
            name: string | null;
            region: { __typename?: "Region"; name: string | null } | null;
          } | null;
        } | null;
      } | null;
    } | null> | null;
  } | null;
};

export type GetCompanyIntentContextQueryVariables = Exact<{
  ids:
    | Array<InputMaybe<Scalars["Identifier"]["input"]>>
    | InputMaybe<Scalars["Identifier"]["input"]>;
  urlId: Scalars["Identifier"]["input"];
  topicId: Scalars["Identifier"]["input"];
  page: Scalars["Int"]["input"];
  per: Scalars["Int"]["input"];
  sort: Array<InputMaybe<Sort>> | InputMaybe<Sort>;
}>;

export type GetCompanyIntentContextQuery = {
  __typename?: "RootQueryType";
  intentContext: {
    __typename?: "IntentContextData";
    count: number | null;
    data: Array<{
      __typename?: "IntentContext";
      id: string | null;
      productName: string | null;
      vendorName: string | null;
      contextType: {
        __typename?: "IntentContextType";
        id: string | null;
        name: string | null;
      } | null;
    } | null> | null;
  } | null;
};

export type UploadKnownCompaniesMutationVariables = Exact<{
  file: Scalars["Upload"]["input"];
  columnIndex: Scalars["Int"]["input"];
  columnCount: Scalars["Int"]["input"];
  hasHeader: Scalars["Boolean"]["input"];
}>;

export type UploadKnownCompaniesMutation = {
  __typename?: "RootMutationType";
  uploadKnownCompanies: {
    __typename?: "KnownCompaniesUpload";
    identifier: string;
    status: KnownCompaniesUploadStatus;
  } | null;
};

export type KnownCompaniesUploadQueryVariables = Exact<{
  identifier: Scalars["String"]["input"];
}>;

export type KnownCompaniesUploadQuery = {
  __typename?: "RootQueryType";
  knownCompaniesUpload: {
    __typename?: "KnownCompaniesUpload";
    identifier: string;
    status: KnownCompaniesUploadStatus;
    totalRows: number | null;
    validRows: number | null;
    invalidRows: number | null;
    matchedRows: number | null;
    error: string | null;
  } | null;
};

export const GetCompanyListBasicDocument = gql`
  query GetCompanyListBasic(
    $filters: OpportunityGeneratorFilter
    $localizeInstalls: Boolean
    $page: Int!
    $per: Int!
    $sort: [Sort]!
    $scoringProfiles: [OpportunityGeneratorScoringProfileSalesplaySearch]
    $tenantId: String
    $modelScores: [ModelScoreInput]
    $modelScoreSort: ModelScoreSortInput
    $modelScoreFilter: [ModelScoreFilterInput]
  ) {
    opportunity_generator_search: opportunityGeneratorSearch(
      filters: $filters
      localizeInstalls: $localizeInstalls
      page: $page
      per: $per
      sort: $sort
      scoringProfiles: $scoringProfiles
      tenantId: $tenantId
      modelScores: $modelScores
      modelScoreSort: $modelScoreSort
      modelScoreFilter: $modelScoreFilter
    ) {
      data {
        hgId
        name
        url
        countryName
        employeeRange {
          min
          max
        }
        revenueRange {
          min
          max
        }
        itSpend
        isGhq
        isDp
        isGp
        scores
        model_scores: modelScores
      }
      count
    }
  }
`;

/**
 * __useGetCompanyListBasicQuery__
 *
 * To run a query within a React component, call `useGetCompanyListBasicQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyListBasicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyListBasicQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      localizeInstalls: // value for 'localizeInstalls'
 *      page: // value for 'page'
 *      per: // value for 'per'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetCompanyListBasicQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    GetCompanyListBasicQuery,
    GetCompanyListBasicQueryVariables
  > &
    (
      | { variables: GetCompanyListBasicQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    GetCompanyListBasicQuery,
    GetCompanyListBasicQueryVariables
  >(GetCompanyListBasicDocument, options);
}
export function useGetCompanyListBasicLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetCompanyListBasicQuery,
    GetCompanyListBasicQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    GetCompanyListBasicQuery,
    GetCompanyListBasicQueryVariables
  >(GetCompanyListBasicDocument, options);
}
export function useGetCompanyListBasicSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        GetCompanyListBasicQuery,
        GetCompanyListBasicQueryVariables
      >
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useSuspenseQuery<
    GetCompanyListBasicQuery,
    GetCompanyListBasicQueryVariables
  >(GetCompanyListBasicDocument, options);
}
export type GetCompanyListBasicQueryHookResult = ReturnType<
  typeof useGetCompanyListBasicQuery
>;
export type GetCompanyListBasicLazyQueryHookResult = ReturnType<
  typeof useGetCompanyListBasicLazyQuery
>;
export type GetCompanyListBasicSuspenseQueryHookResult = ReturnType<
  typeof useGetCompanyListBasicSuspenseQuery
>;
export type GetCompanyListBasicQueryResult = Apollo.QueryResult<
  GetCompanyListBasicQuery,
  GetCompanyListBasicQueryVariables
>;
export const GetCompanyListWithFiltersDocument = gql`
  query GetCompanyListWithFilters(
    $filters: OpportunityGeneratorFilter
    $localizeInstalls: Boolean
    $page: Int!
    $per: Int!
    $sort: [Sort]!
    $competitorPresence: [Int!]
    $companyMatchFile: CompanyMatchFilter
  ) {
    opportunity_generator_search: opportunityGeneratorSearch(
      filters: $filters
      localizeInstalls: $localizeInstalls
      page: $page
      per: $per
      sort: $sort
      competitorPresence: $competitorPresence
      companyMatchFile: $companyMatchFile
    ) {
      data {
        hgId
        name
        url
        countryName
        employeeRange {
          min
          max
        }
        revenueRange {
          min
          max
        }
        itSpend
        isGhq
        isDp
        isGp
        competitorPresence
        isWhitespace
        isProspectWhitespace
        isExpansionWhitespace
      }
      count
    }
  }
`;

/**
 * __useGetCompanyListWithFiltersQuery__
 *
 * To run a query within a React component, call `useGetCompanyListWithFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyListWithFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyListWithFiltersQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *      localizeInstalls: // value for 'localizeInstalls'
 *      page: // value for 'page'
 *      per: // value for 'per'
 *      sort: // value for 'sort'
 *      competitorPresence: // value for 'competitorPresence'
 *      companyMatchFile: // value for 'companyMatchFile'
 *   },
 * });
 */
export function useGetCompanyListWithFiltersQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    GetCompanyListWithFiltersQuery,
    GetCompanyListWithFiltersQueryVariables
  > &
    (
      | { variables: GetCompanyListWithFiltersQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    GetCompanyListWithFiltersQuery,
    GetCompanyListWithFiltersQueryVariables
  >(GetCompanyListWithFiltersDocument, options);
}
export function useGetCompanyListWithFiltersLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetCompanyListWithFiltersQuery,
    GetCompanyListWithFiltersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    GetCompanyListWithFiltersQuery,
    GetCompanyListWithFiltersQueryVariables
  >(GetCompanyListWithFiltersDocument, options);
}
export function useGetCompanyListWithFiltersSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        GetCompanyListWithFiltersQuery,
        GetCompanyListWithFiltersQueryVariables
      >
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useSuspenseQuery<
    GetCompanyListWithFiltersQuery,
    GetCompanyListWithFiltersQueryVariables
  >(GetCompanyListWithFiltersDocument, options);
}
export type GetCompanyListWithFiltersQueryHookResult = ReturnType<
  typeof useGetCompanyListWithFiltersQuery
>;
export type GetCompanyListWithFiltersLazyQueryHookResult = ReturnType<
  typeof useGetCompanyListWithFiltersLazyQuery
>;
export type GetCompanyListWithFiltersSuspenseQueryHookResult = ReturnType<
  typeof useGetCompanyListWithFiltersSuspenseQuery
>;
export type GetCompanyListWithFiltersQueryResult = Apollo.QueryResult<
  GetCompanyListWithFiltersQuery,
  GetCompanyListWithFiltersQueryVariables
>;
export const GetCompanyIntentDocument = gql`
  query GetCompanyIntent(
    $hgIds: [Identifier]!
    $includeCorporateDescendants: Boolean
    $urlInstallIds: [Identifier]
    $page: Int!
    $per: Int!
    $sort: [Sort]!
    $intent: IntentFilter
    $ignoreProvisioning: Boolean
    $techTopicsOnly: Boolean
  ) {
    intent(
      hgIds: $hgIds
      includeCorporateDescendants: $includeCorporateDescendants
      urlInstallIds: $urlInstallIds
      page: $page
      per: $per
      sort: $sort
      intent: $intent
      ignoreProvisioning: $ignoreProvisioning
      techTopicsOnly: $techTopicsOnly
    ) {
      count
      data {
        url
        urlId
        score
        trend
        lastSeenAt
        locationScore
        topic {
          id
          displayName
        }
        buyersJourney {
          id
          name
        }
        contextAggregate {
          contextIds
          typeNames
        }
        location {
          cities
          state {
            id
            name
            country {
              alpha2
              name
              region {
                name
              }
            }
          }
        }
      }
    }
  }
`;

/**
 * __useGetCompanyIntentQuery__
 *
 * To run a query within a React component, call `useGetCompanyIntentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyIntentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyIntentQuery({
 *   variables: {
 *      hgIds: // value for 'hgIds'
 *      includeCorporateDescendants: // value for 'includeCorporateDescendants'
 *      urlInstallIds: // value for 'urlInstallIds'
 *      page: // value for 'page'
 *      per: // value for 'per'
 *      sort: // value for 'sort'
 *      intent: // value for 'intent'
 *      ignoreProvisioning: // value for 'ignoreProvisioning'
 *      techTopicsOnly: // value for 'techTopicsOnly'
 *   },
 * });
 */
export function useGetCompanyIntentQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    GetCompanyIntentQuery,
    GetCompanyIntentQueryVariables
  > &
    (
      | { variables: GetCompanyIntentQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    GetCompanyIntentQuery,
    GetCompanyIntentQueryVariables
  >(GetCompanyIntentDocument, options);
}
export function useGetCompanyIntentLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetCompanyIntentQuery,
    GetCompanyIntentQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    GetCompanyIntentQuery,
    GetCompanyIntentQueryVariables
  >(GetCompanyIntentDocument, options);
}
export function useGetCompanyIntentSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        GetCompanyIntentQuery,
        GetCompanyIntentQueryVariables
      >
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useSuspenseQuery<
    GetCompanyIntentQuery,
    GetCompanyIntentQueryVariables
  >(GetCompanyIntentDocument, options);
}
export type GetCompanyIntentQueryHookResult = ReturnType<
  typeof useGetCompanyIntentQuery
>;
export type GetCompanyIntentLazyQueryHookResult = ReturnType<
  typeof useGetCompanyIntentLazyQuery
>;
export type GetCompanyIntentSuspenseQueryHookResult = ReturnType<
  typeof useGetCompanyIntentSuspenseQuery
>;
export type GetCompanyIntentQueryResult = Apollo.QueryResult<
  GetCompanyIntentQuery,
  GetCompanyIntentQueryVariables
>;
export const GetCompanyIntentContextDocument = gql`
  query GetCompanyIntentContext(
    $ids: [Identifier]!
    $urlId: Identifier!
    $topicId: Identifier!
    $page: Int!
    $per: Int!
    $sort: [Sort]!
  ) {
    intentContext(
      ids: $ids
      urlId: $urlId
      topicId: $topicId
      page: $page
      per: $per
      sort: $sort
    ) {
      count
      data {
        id
        contextType {
          id
          name
        }
        productName
        vendorName
      }
    }
  }
`;

/**
 * __useGetCompanyIntentContextQuery__
 *
 * To run a query within a React component, call `useGetCompanyIntentContextQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyIntentContextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyIntentContextQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *      urlId: // value for 'urlId'
 *      topicId: // value for 'topicId'
 *      page: // value for 'page'
 *      per: // value for 'per'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetCompanyIntentContextQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    GetCompanyIntentContextQuery,
    GetCompanyIntentContextQueryVariables
  > &
    (
      | { variables: GetCompanyIntentContextQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    GetCompanyIntentContextQuery,
    GetCompanyIntentContextQueryVariables
  >(GetCompanyIntentContextDocument, options);
}
export function useGetCompanyIntentContextLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetCompanyIntentContextQuery,
    GetCompanyIntentContextQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    GetCompanyIntentContextQuery,
    GetCompanyIntentContextQueryVariables
  >(GetCompanyIntentContextDocument, options);
}
export function useGetCompanyIntentContextSuspenseQuery(
  baseOptions?:
    | ApolloReactHooks.SkipToken
    | ApolloReactHooks.SuspenseQueryHookOptions<
        GetCompanyIntentContextQuery,
        GetCompanyIntentContextQueryVariables
      >
) {
  const options =
    baseOptions === ApolloReactHooks.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useSuspenseQuery<
    GetCompanyIntentContextQuery,
    GetCompanyIntentContextQueryVariables
  >(GetCompanyIntentContextDocument, options);
}
export type GetCompanyIntentContextQueryHookResult = ReturnType<
  typeof useGetCompanyIntentContextQuery
>;
export type GetCompanyIntentContextLazyQueryHookResult = ReturnType<
  typeof useGetCompanyIntentContextLazyQuery
>;
export type GetCompanyIntentContextSuspenseQueryHookResult = ReturnType<
  typeof useGetCompanyIntentContextSuspenseQuery
>;
export type GetCompanyIntentContextQueryResult = Apollo.QueryResult<
  GetCompanyIntentContextQuery,
  GetCompanyIntentContextQueryVariables
>;
export const UploadKnownCompaniesDocument = gql`
  mutation UploadKnownCompanies(
    $file: Upload!
    $columnIndex: Int!
    $columnCount: Int!
    $hasHeader: Boolean!
  ) {
    uploadKnownCompanies(
      file: $file
      columnIndex: $columnIndex
      columnCount: $columnCount
      hasHeader: $hasHeader
    ) {
      identifier
      status
    }
  }
`;
export type UploadKnownCompaniesMutationFn = Apollo.MutationFunction<
  UploadKnownCompaniesMutation,
  UploadKnownCompaniesMutationVariables
>;

/**
 * __useUploadKnownCompaniesMutation__
 *
 * To run a mutation, you first call `useUploadKnownCompaniesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadKnownCompaniesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadKnownCompaniesMutation, { data, loading, error }] = useUploadKnownCompaniesMutation({
 *   variables: {
 *      file: // value for 'file'
 *      columnIndex: // value for 'columnIndex'
 *      columnCount: // value for 'columnCount'
 *      hasHeader: // value for 'hasHeader'
 *   },
 * });
 */
export function useUploadKnownCompaniesMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UploadKnownCompaniesMutation,
    UploadKnownCompaniesMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useMutation<
    UploadKnownCompaniesMutation,
    UploadKnownCompaniesMutationVariables
  >(UploadKnownCompaniesDocument, options);
}
export type UploadKnownCompaniesMutationHookResult = ReturnType<
  typeof useUploadKnownCompaniesMutation
>;
export type UploadKnownCompaniesMutationResult =
  Apollo.MutationResult<UploadKnownCompaniesMutation>;
export type UploadKnownCompaniesMutationOptions = Apollo.BaseMutationOptions<
  UploadKnownCompaniesMutation,
  UploadKnownCompaniesMutationVariables
>;
export const KnownCompaniesUploadDocument = gql`
  query KnownCompaniesUpload($identifier: String!) {
    knownCompaniesUpload(identifier: $identifier) {
      identifier
      status
      totalRows
      validRows
      invalidRows
      matchedRows
      error
    }
  }
`;

/**
 * __useKnownCompaniesUploadLazyQuery__
 *
 * To run a query within a React component, call `useKnownCompaniesUploadLazyQuery` and pass it any options that fit your needs.
 */
export function useKnownCompaniesUploadLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    KnownCompaniesUploadQuery,
    KnownCompaniesUploadQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    KnownCompaniesUploadQuery,
    KnownCompaniesUploadQueryVariables
  >(KnownCompaniesUploadDocument, options);
}
export type KnownCompaniesUploadLazyQueryHookResult = ReturnType<
  typeof useKnownCompaniesUploadLazyQuery
>;
export type KnownCompaniesUploadQueryResult = Apollo.QueryResult<
  KnownCompaniesUploadQuery,
  KnownCompaniesUploadQueryVariables
>;
